// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/contractintel/v1/contractintel.proto (package mono.contractintel.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { AwardPricedDuty, PaginationRequest, PaginationResponse, RequestMetadata, ReviewItem, ReviewStatement } from "../../common/v1/types_pb";
/**
 * @generated from enum mono.contractintel.v1.ContractType
 */ export var ContractType = /*#__PURE__*/ function(ContractType) {
    /**
   * @generated from enum value: CONTRACT_TYPE_UNSPECIFIED = 0;
   */ ContractType[ContractType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CONTRACT_TYPE_FFP = 1;
   */ ContractType[ContractType["FFP"] = 1] = "FFP";
    /**
   * @generated from enum value: CONTRACT_TYPE_TM = 2;
   */ ContractType[ContractType["TM"] = 2] = "TM";
    /**
   * @generated from enum value: CONTRACT_TYPE_CPFF = 3;
   */ ContractType[ContractType["CPFF"] = 3] = "CPFF";
    /**
   * @generated from enum value: CONTRACT_TYPE_CPIF = 4;
   */ ContractType[ContractType["CPIF"] = 4] = "CPIF";
    /**
   * @generated from enum value: CONTRACT_TYPE_CPAF = 5;
   */ ContractType[ContractType["CPAF"] = 5] = "CPAF";
    /**
   * @generated from enum value: CONTRACT_TYPE_IDIQ = 6;
   */ ContractType[ContractType["IDIQ"] = 6] = "IDIQ";
    /**
   * @generated from enum value: CONTRACT_TYPE_BPA = 7;
   */ ContractType[ContractType["BPA"] = 7] = "BPA";
    /**
   * @generated from enum value: CONTRACT_TYPE_HYBRID = 8;
   */ ContractType[ContractType["HYBRID"] = 8] = "HYBRID";
    /**
   * @generated from enum value: CONTRACT_TYPE_OTHER = 9;
   */ ContractType[ContractType["OTHER"] = 9] = "OTHER";
    return ContractType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ContractType)
proto3.util.setEnumType(ContractType, "mono.contractintel.v1.ContractType", [
    {
        no: 0,
        name: "CONTRACT_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CONTRACT_TYPE_FFP"
    },
    {
        no: 2,
        name: "CONTRACT_TYPE_TM"
    },
    {
        no: 3,
        name: "CONTRACT_TYPE_CPFF"
    },
    {
        no: 4,
        name: "CONTRACT_TYPE_CPIF"
    },
    {
        no: 5,
        name: "CONTRACT_TYPE_CPAF"
    },
    {
        no: 6,
        name: "CONTRACT_TYPE_IDIQ"
    },
    {
        no: 7,
        name: "CONTRACT_TYPE_BPA"
    },
    {
        no: 8,
        name: "CONTRACT_TYPE_HYBRID"
    },
    {
        no: 9,
        name: "CONTRACT_TYPE_OTHER"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ContractAnalysisStatus
 */ export var ContractAnalysisStatus = /*#__PURE__*/ function(ContractAnalysisStatus) {
    /**
   * @generated from enum value: CONTRACT_ANALYSIS_STATUS_UNSPECIFIED = 0;
   */ ContractAnalysisStatus[ContractAnalysisStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CONTRACT_ANALYSIS_STATUS_PROCESSING = 1;
   */ ContractAnalysisStatus[ContractAnalysisStatus["PROCESSING"] = 1] = "PROCESSING";
    /**
   * @generated from enum value: CONTRACT_ANALYSIS_STATUS_COMPLETED = 2;
   */ ContractAnalysisStatus[ContractAnalysisStatus["COMPLETED"] = 2] = "COMPLETED";
    /**
   * @generated from enum value: CONTRACT_ANALYSIS_STATUS_FAILED = 3;
   */ ContractAnalysisStatus[ContractAnalysisStatus["FAILED"] = 3] = "FAILED";
    /**
   * CLINs extraction failed but record exists
   *
   * @generated from enum value: CONTRACT_ANALYSIS_STATUS_PARTIAL = 4;
   */ ContractAnalysisStatus[ContractAnalysisStatus["PARTIAL"] = 4] = "PARTIAL";
    return ContractAnalysisStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ContractAnalysisStatus)
proto3.util.setEnumType(ContractAnalysisStatus, "mono.contractintel.v1.ContractAnalysisStatus", [
    {
        no: 0,
        name: "CONTRACT_ANALYSIS_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CONTRACT_ANALYSIS_STATUS_PROCESSING"
    },
    {
        no: 2,
        name: "CONTRACT_ANALYSIS_STATUS_COMPLETED"
    },
    {
        no: 3,
        name: "CONTRACT_ANALYSIS_STATUS_FAILED"
    },
    {
        no: 4,
        name: "CONTRACT_ANALYSIS_STATUS_PARTIAL"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.CLINOptionType
 */ export var CLINOptionType = /*#__PURE__*/ function(CLINOptionType) {
    /**
   * @generated from enum value: CLIN_OPTION_TYPE_UNSPECIFIED = 0;
   */ CLINOptionType[CLINOptionType["CLIN_OPTION_TYPE_UNSPECIFIED"] = 0] = "CLIN_OPTION_TYPE_UNSPECIFIED";
    /**
   * @generated from enum value: CLIN_OPTION_TYPE_BASE = 1;
   */ CLINOptionType[CLINOptionType["CLIN_OPTION_TYPE_BASE"] = 1] = "CLIN_OPTION_TYPE_BASE";
    /**
   * @generated from enum value: CLIN_OPTION_TYPE_OPTION_PERIOD = 2;
   */ CLINOptionType[CLINOptionType["CLIN_OPTION_TYPE_OPTION_PERIOD"] = 2] = "CLIN_OPTION_TYPE_OPTION_PERIOD";
    /**
   * @generated from enum value: CLIN_OPTION_TYPE_OPTIONAL_TASK = 3;
   */ CLINOptionType[CLINOptionType["CLIN_OPTION_TYPE_OPTIONAL_TASK"] = 3] = "CLIN_OPTION_TYPE_OPTIONAL_TASK";
    return CLINOptionType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(CLINOptionType)
proto3.util.setEnumType(CLINOptionType, "mono.contractintel.v1.CLINOptionType", [
    {
        no: 0,
        name: "CLIN_OPTION_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CLIN_OPTION_TYPE_BASE"
    },
    {
        no: 2,
        name: "CLIN_OPTION_TYPE_OPTION_PERIOD"
    },
    {
        no: 3,
        name: "CLIN_OPTION_TYPE_OPTIONAL_TASK"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.CLINContractType
 */ export var CLINContractType = /*#__PURE__*/ function(CLINContractType) {
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_UNSPECIFIED = 0;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_UNSPECIFIED"] = 0] = "CLIN_CONTRACT_TYPE_UNSPECIFIED";
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_FFP = 1;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_FFP"] = 1] = "CLIN_CONTRACT_TYPE_FFP";
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_TM = 2;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_TM"] = 2] = "CLIN_CONTRACT_TYPE_TM";
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_CPFF = 3;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_CPFF"] = 3] = "CLIN_CONTRACT_TYPE_CPFF";
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_CPIF = 4;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_CPIF"] = 4] = "CLIN_CONTRACT_TYPE_CPIF";
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_CPAF = 5;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_CPAF"] = 5] = "CLIN_CONTRACT_TYPE_CPAF";
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_LABOR_HOUR = 6;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_LABOR_HOUR"] = 6] = "CLIN_CONTRACT_TYPE_LABOR_HOUR";
    /**
   * @generated from enum value: CLIN_CONTRACT_TYPE_OTHER = 7;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_OTHER"] = 7] = "CLIN_CONTRACT_TYPE_OTHER";
    /**
   * Cost reimbursable, e.g. a travel line under the Federal Travel
   * Regulation. Without it a CR line read as OTHER on the wire.
   *
   * @generated from enum value: CLIN_CONTRACT_TYPE_CR = 8;
   */ CLINContractType[CLINContractType["CLIN_CONTRACT_TYPE_CR"] = 8] = "CLIN_CONTRACT_TYPE_CR";
    return CLINContractType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(CLINContractType)
proto3.util.setEnumType(CLINContractType, "mono.contractintel.v1.CLINContractType", [
    {
        no: 0,
        name: "CLIN_CONTRACT_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CLIN_CONTRACT_TYPE_FFP"
    },
    {
        no: 2,
        name: "CLIN_CONTRACT_TYPE_TM"
    },
    {
        no: 3,
        name: "CLIN_CONTRACT_TYPE_CPFF"
    },
    {
        no: 4,
        name: "CLIN_CONTRACT_TYPE_CPIF"
    },
    {
        no: 5,
        name: "CLIN_CONTRACT_TYPE_CPAF"
    },
    {
        no: 6,
        name: "CLIN_CONTRACT_TYPE_LABOR_HOUR"
    },
    {
        no: 7,
        name: "CLIN_CONTRACT_TYPE_OTHER"
    },
    {
        no: 8,
        name: "CLIN_CONTRACT_TYPE_CR"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.FundingStatus
 */ export var FundingStatus = /*#__PURE__*/ function(FundingStatus) {
    /**
   * @generated from enum value: FUNDING_STATUS_UNSPECIFIED = 0;
   */ FundingStatus[FundingStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: FUNDING_STATUS_FULLY_FUNDED = 1;
   */ FundingStatus[FundingStatus["FULLY_FUNDED"] = 1] = "FULLY_FUNDED";
    /**
   * @generated from enum value: FUNDING_STATUS_INCREMENTALLY_FUNDED = 2;
   */ FundingStatus[FundingStatus["INCREMENTALLY_FUNDED"] = 2] = "INCREMENTALLY_FUNDED";
    /**
   * @generated from enum value: FUNDING_STATUS_UNFUNDED = 3;
   */ FundingStatus[FundingStatus["UNFUNDED"] = 3] = "UNFUNDED";
    return FundingStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(FundingStatus)
proto3.util.setEnumType(FundingStatus, "mono.contractintel.v1.FundingStatus", [
    {
        no: 0,
        name: "FUNDING_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "FUNDING_STATUS_FULLY_FUNDED"
    },
    {
        no: 2,
        name: "FUNDING_STATUS_INCREMENTALLY_FUNDED"
    },
    {
        no: 3,
        name: "FUNDING_STATUS_UNFUNDED"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.SublineType
 */ export var SublineType = /*#__PURE__*/ function(SublineType) {
    /**
   * @generated from enum value: SUBLINE_TYPE_UNSPECIFIED = 0;
   */ SublineType[SublineType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: SUBLINE_TYPE_SEPARATELY_PRICED = 1;
   */ SublineType[SublineType["SEPARATELY_PRICED"] = 1] = "SEPARATELY_PRICED";
    /**
   * @generated from enum value: SUBLINE_TYPE_INFORMATIONAL = 2;
   */ SublineType[SublineType["INFORMATIONAL"] = 2] = "INFORMATIONAL";
    /**
   * @generated from enum value: SUBLINE_TYPE_FUNDING = 3;
   */ SublineType[SublineType["FUNDING"] = 3] = "FUNDING";
    return SublineType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(SublineType)
proto3.util.setEnumType(SublineType, "mono.contractintel.v1.SublineType", [
    {
        no: 0,
        name: "SUBLINE_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "SUBLINE_TYPE_SEPARATELY_PRICED"
    },
    {
        no: 2,
        name: "SUBLINE_TYPE_INFORMATIONAL"
    },
    {
        no: 3,
        name: "SUBLINE_TYPE_FUNDING"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ModificationType
 */ export var ModificationType = /*#__PURE__*/ function(ModificationType) {
    /**
   * @generated from enum value: MODIFICATION_TYPE_UNSPECIFIED = 0;
   */ ModificationType[ModificationType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: MODIFICATION_TYPE_BILATERAL = 1;
   */ ModificationType[ModificationType["BILATERAL"] = 1] = "BILATERAL";
    /**
   * @generated from enum value: MODIFICATION_TYPE_UNILATERAL = 2;
   */ ModificationType[ModificationType["UNILATERAL"] = 2] = "UNILATERAL";
    /**
   * @generated from enum value: MODIFICATION_TYPE_ADMINISTRATIVE = 3;
   */ ModificationType[ModificationType["ADMINISTRATIVE"] = 3] = "ADMINISTRATIVE";
    /**
   * @generated from enum value: MODIFICATION_TYPE_CHANGE_ORDER = 4;
   */ ModificationType[ModificationType["CHANGE_ORDER"] = 4] = "CHANGE_ORDER";
    /**
   * @generated from enum value: MODIFICATION_TYPE_SUPPLEMENTAL = 5;
   */ ModificationType[ModificationType["SUPPLEMENTAL"] = 5] = "SUPPLEMENTAL";
    return ModificationType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ModificationType)
proto3.util.setEnumType(ModificationType, "mono.contractintel.v1.ModificationType", [
    {
        no: 0,
        name: "MODIFICATION_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "MODIFICATION_TYPE_BILATERAL"
    },
    {
        no: 2,
        name: "MODIFICATION_TYPE_UNILATERAL"
    },
    {
        no: 3,
        name: "MODIFICATION_TYPE_ADMINISTRATIVE"
    },
    {
        no: 4,
        name: "MODIFICATION_TYPE_CHANGE_ORDER"
    },
    {
        no: 5,
        name: "MODIFICATION_TYPE_SUPPLEMENTAL"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ModificationStatus
 */ export var ModificationStatus = /*#__PURE__*/ function(ModificationStatus) {
    /**
   * @generated from enum value: MODIFICATION_STATUS_UNSPECIFIED = 0;
   */ ModificationStatus[ModificationStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: MODIFICATION_STATUS_DRAFT = 1;
   */ ModificationStatus[ModificationStatus["DRAFT"] = 1] = "DRAFT";
    /**
   * @generated from enum value: MODIFICATION_STATUS_APPLIED = 2;
   */ ModificationStatus[ModificationStatus["APPLIED"] = 2] = "APPLIED";
    /**
   * @generated from enum value: MODIFICATION_STATUS_REJECTED = 3;
   */ ModificationStatus[ModificationStatus["REJECTED"] = 3] = "REJECTED";
    /**
   * @generated from enum value: MODIFICATION_STATUS_PENDING = 4;
   */ ModificationStatus[ModificationStatus["PENDING"] = 4] = "PENDING";
    return ModificationStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ModificationStatus)
proto3.util.setEnumType(ModificationStatus, "mono.contractintel.v1.ModificationStatus", [
    {
        no: 0,
        name: "MODIFICATION_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "MODIFICATION_STATUS_DRAFT"
    },
    {
        no: 2,
        name: "MODIFICATION_STATUS_APPLIED"
    },
    {
        no: 3,
        name: "MODIFICATION_STATUS_REJECTED"
    },
    {
        no: 4,
        name: "MODIFICATION_STATUS_PENDING"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ChangeCategory
 */ export var ChangeCategory = /*#__PURE__*/ function(ChangeCategory) {
    /**
   * @generated from enum value: CHANGE_CATEGORY_UNSPECIFIED = 0;
   */ ChangeCategory[ChangeCategory["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CHANGE_CATEGORY_SCOPE = 1;
   */ ChangeCategory[ChangeCategory["SCOPE"] = 1] = "SCOPE";
    /**
   * @generated from enum value: CHANGE_CATEGORY_FUNDING = 2;
   */ ChangeCategory[ChangeCategory["FUNDING"] = 2] = "FUNDING";
    /**
   * @generated from enum value: CHANGE_CATEGORY_PERIOD_EXTENSION = 3;
   */ ChangeCategory[ChangeCategory["PERIOD_EXTENSION"] = 3] = "PERIOD_EXTENSION";
    /**
   * @generated from enum value: CHANGE_CATEGORY_OPTION_EXERCISE = 4;
   */ ChangeCategory[ChangeCategory["OPTION_EXERCISE"] = 4] = "OPTION_EXERCISE";
    /**
   * @generated from enum value: CHANGE_CATEGORY_KEY_PERSONNEL = 5;
   */ ChangeCategory[ChangeCategory["KEY_PERSONNEL"] = 5] = "KEY_PERSONNEL";
    /**
   * @generated from enum value: CHANGE_CATEGORY_ADMINISTRATIVE = 6;
   */ ChangeCategory[ChangeCategory["ADMINISTRATIVE"] = 6] = "ADMINISTRATIVE";
    /**
   * @generated from enum value: CHANGE_CATEGORY_TERMS_CONDITIONS = 7;
   */ ChangeCategory[ChangeCategory["TERMS_CONDITIONS"] = 7] = "TERMS_CONDITIONS";
    return ChangeCategory;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ChangeCategory)
proto3.util.setEnumType(ChangeCategory, "mono.contractintel.v1.ChangeCategory", [
    {
        no: 0,
        name: "CHANGE_CATEGORY_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CHANGE_CATEGORY_SCOPE"
    },
    {
        no: 2,
        name: "CHANGE_CATEGORY_FUNDING"
    },
    {
        no: 3,
        name: "CHANGE_CATEGORY_PERIOD_EXTENSION"
    },
    {
        no: 4,
        name: "CHANGE_CATEGORY_OPTION_EXERCISE"
    },
    {
        no: 5,
        name: "CHANGE_CATEGORY_KEY_PERSONNEL"
    },
    {
        no: 6,
        name: "CHANGE_CATEGORY_ADMINISTRATIVE"
    },
    {
        no: 7,
        name: "CHANGE_CATEGORY_TERMS_CONDITIONS"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.DeliverableType
 */ export var DeliverableType = /*#__PURE__*/ function(DeliverableType) {
    /**
   * @generated from enum value: DELIVERABLE_TYPE_UNSPECIFIED = 0;
   */ DeliverableType[DeliverableType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DELIVERABLE_TYPE_DATA = 1;
   */ DeliverableType[DeliverableType["DATA"] = 1] = "DATA";
    /**
   * @generated from enum value: DELIVERABLE_TYPE_REPORT = 2;
   */ DeliverableType[DeliverableType["REPORT"] = 2] = "REPORT";
    /**
   * @generated from enum value: DELIVERABLE_TYPE_SOFTWARE = 3;
   */ DeliverableType[DeliverableType["SOFTWARE"] = 3] = "SOFTWARE";
    /**
   * @generated from enum value: DELIVERABLE_TYPE_HARDWARE = 4;
   */ DeliverableType[DeliverableType["HARDWARE"] = 4] = "HARDWARE";
    /**
   * @generated from enum value: DELIVERABLE_TYPE_SERVICE = 5;
   */ DeliverableType[DeliverableType["SERVICE"] = 5] = "SERVICE";
    /**
   * @generated from enum value: DELIVERABLE_TYPE_OTHER = 6;
   */ DeliverableType[DeliverableType["OTHER"] = 6] = "OTHER";
    return DeliverableType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DeliverableType)
proto3.util.setEnumType(DeliverableType, "mono.contractintel.v1.DeliverableType", [
    {
        no: 0,
        name: "DELIVERABLE_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DELIVERABLE_TYPE_DATA"
    },
    {
        no: 2,
        name: "DELIVERABLE_TYPE_REPORT"
    },
    {
        no: 3,
        name: "DELIVERABLE_TYPE_SOFTWARE"
    },
    {
        no: 4,
        name: "DELIVERABLE_TYPE_HARDWARE"
    },
    {
        no: 5,
        name: "DELIVERABLE_TYPE_SERVICE"
    },
    {
        no: 6,
        name: "DELIVERABLE_TYPE_OTHER"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.SourceKindV2
 */ export var SourceKindV2 = /*#__PURE__*/ function(SourceKindV2) {
    /**
   * @generated from enum value: SOURCE_KIND_V2_UNSPECIFIED = 0;
   */ SourceKindV2[SourceKindV2["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: SOURCE_KIND_V2_PROPOSAL_BASELINE = 1;
   */ SourceKindV2[SourceKindV2["PROPOSAL_BASELINE"] = 1] = "PROPOSAL_BASELINE";
    /**
   * @generated from enum value: SOURCE_KIND_V2_PRE_AWARD = 2;
   */ SourceKindV2[SourceKindV2["PRE_AWARD"] = 2] = "PRE_AWARD";
    /**
   * @generated from enum value: SOURCE_KIND_V2_FINAL_CONTRACT = 3;
   */ SourceKindV2[SourceKindV2["FINAL_CONTRACT"] = 3] = "FINAL_CONTRACT";
    /**
   * @generated from enum value: SOURCE_KIND_V2_AWARD_COMPARISON = 4;
   */ SourceKindV2[SourceKindV2["AWARD_COMPARISON"] = 4] = "AWARD_COMPARISON";
    /**
   * @generated from enum value: SOURCE_KIND_V2_MODIFICATION = 5;
   */ SourceKindV2[SourceKindV2["MODIFICATION"] = 5] = "MODIFICATION";
    /**
   * @generated from enum value: SOURCE_KIND_V2_MANUAL = 6;
   */ SourceKindV2[SourceKindV2["MANUAL"] = 6] = "MANUAL";
    /**
   * @generated from enum value: SOURCE_KIND_V2_RE_EXTRACTION = 7;
   */ SourceKindV2[SourceKindV2["RE_EXTRACTION"] = 7] = "RE_EXTRACTION";
    return SourceKindV2;
}({});
// Retrieve enum metadata with: proto3.getEnumType(SourceKindV2)
proto3.util.setEnumType(SourceKindV2, "mono.contractintel.v1.SourceKindV2", [
    {
        no: 0,
        name: "SOURCE_KIND_V2_UNSPECIFIED"
    },
    {
        no: 1,
        name: "SOURCE_KIND_V2_PROPOSAL_BASELINE"
    },
    {
        no: 2,
        name: "SOURCE_KIND_V2_PRE_AWARD"
    },
    {
        no: 3,
        name: "SOURCE_KIND_V2_FINAL_CONTRACT"
    },
    {
        no: 4,
        name: "SOURCE_KIND_V2_AWARD_COMPARISON"
    },
    {
        no: 5,
        name: "SOURCE_KIND_V2_MODIFICATION"
    },
    {
        no: 6,
        name: "SOURCE_KIND_V2_MANUAL"
    },
    {
        no: 7,
        name: "SOURCE_KIND_V2_RE_EXTRACTION"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.SourceReviewState
 */ export var SourceReviewState = /*#__PURE__*/ function(SourceReviewState) {
    /**
   * @generated from enum value: SOURCE_REVIEW_STATE_UNSPECIFIED = 0;
   */ SourceReviewState[SourceReviewState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: SOURCE_REVIEW_STATE_UNREVIEWED = 1;
   */ SourceReviewState[SourceReviewState["UNREVIEWED"] = 1] = "UNREVIEWED";
    /**
   * @generated from enum value: SOURCE_REVIEW_STATE_APPROVED = 2;
   */ SourceReviewState[SourceReviewState["APPROVED"] = 2] = "APPROVED";
    /**
   * @generated from enum value: SOURCE_REVIEW_STATE_REJECTED = 3;
   */ SourceReviewState[SourceReviewState["REJECTED"] = 3] = "REJECTED";
    /**
   * @generated from enum value: SOURCE_REVIEW_STATE_CORRECTED = 4;
   */ SourceReviewState[SourceReviewState["CORRECTED"] = 4] = "CORRECTED";
    /**
   * @generated from enum value: SOURCE_REVIEW_STATE_WAIVED = 5;
   */ SourceReviewState[SourceReviewState["WAIVED"] = 5] = "WAIVED";
    /**
   * @generated from enum value: SOURCE_REVIEW_STATE_ESCALATED = 6;
   */ SourceReviewState[SourceReviewState["ESCALATED"] = 6] = "ESCALATED";
    return SourceReviewState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(SourceReviewState)
proto3.util.setEnumType(SourceReviewState, "mono.contractintel.v1.SourceReviewState", [
    {
        no: 0,
        name: "SOURCE_REVIEW_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "SOURCE_REVIEW_STATE_UNREVIEWED"
    },
    {
        no: 2,
        name: "SOURCE_REVIEW_STATE_APPROVED"
    },
    {
        no: 3,
        name: "SOURCE_REVIEW_STATE_REJECTED"
    },
    {
        no: 4,
        name: "SOURCE_REVIEW_STATE_CORRECTED"
    },
    {
        no: 5,
        name: "SOURCE_REVIEW_STATE_WAIVED"
    },
    {
        no: 6,
        name: "SOURCE_REVIEW_STATE_ESCALATED"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ContractPartyRole
 */ export var ContractPartyRole = /*#__PURE__*/ function(ContractPartyRole) {
    /**
   * @generated from enum value: CONTRACT_PARTY_ROLE_UNSPECIFIED = 0;
   */ ContractPartyRole[ContractPartyRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CONTRACT_PARTY_ROLE_PRIME = 1;
   */ ContractPartyRole[ContractPartyRole["PRIME"] = 1] = "PRIME";
    /**
   * @generated from enum value: CONTRACT_PARTY_ROLE_SUBCONTRACTOR = 2;
   */ ContractPartyRole[ContractPartyRole["SUBCONTRACTOR"] = 2] = "SUBCONTRACTOR";
    /**
   * @generated from enum value: CONTRACT_PARTY_ROLE_JOINT_VENTURE = 3;
   */ ContractPartyRole[ContractPartyRole["JOINT_VENTURE"] = 3] = "JOINT_VENTURE";
    /**
   * @generated from enum value: CONTRACT_PARTY_ROLE_MENTOR = 4;
   */ ContractPartyRole[ContractPartyRole["MENTOR"] = 4] = "MENTOR";
    /**
   * @generated from enum value: CONTRACT_PARTY_ROLE_PROTEGE = 5;
   */ ContractPartyRole[ContractPartyRole["PROTEGE"] = 5] = "PROTEGE";
    return ContractPartyRole;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ContractPartyRole)
proto3.util.setEnumType(ContractPartyRole, "mono.contractintel.v1.ContractPartyRole", [
    {
        no: 0,
        name: "CONTRACT_PARTY_ROLE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CONTRACT_PARTY_ROLE_PRIME"
    },
    {
        no: 2,
        name: "CONTRACT_PARTY_ROLE_SUBCONTRACTOR"
    },
    {
        no: 3,
        name: "CONTRACT_PARTY_ROLE_JOINT_VENTURE"
    },
    {
        no: 4,
        name: "CONTRACT_PARTY_ROLE_MENTOR"
    },
    {
        no: 5,
        name: "CONTRACT_PARTY_ROLE_PROTEGE"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ContractDateType
 */ export var ContractDateType = /*#__PURE__*/ function(ContractDateType) {
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_UNSPECIFIED = 0;
   */ ContractDateType[ContractDateType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_AWARD = 1;
   */ ContractDateType[ContractDateType["AWARD"] = 1] = "AWARD";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_EFFECTIVE = 2;
   */ ContractDateType[ContractDateType["EFFECTIVE"] = 2] = "EFFECTIVE";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_SIGNED = 3;
   */ ContractDateType[ContractDateType["SIGNED"] = 3] = "SIGNED";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_BASE_POP_START = 4;
   */ ContractDateType[ContractDateType["BASE_POP_START"] = 4] = "BASE_POP_START";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_BASE_POP_END = 5;
   */ ContractDateType[ContractDateType["BASE_POP_END"] = 5] = "BASE_POP_END";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_OPTION_POP_START = 6;
   */ ContractDateType[ContractDateType["OPTION_POP_START"] = 6] = "OPTION_POP_START";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_OPTION_POP_END = 7;
   */ ContractDateType[ContractDateType["OPTION_POP_END"] = 7] = "OPTION_POP_END";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_ORDERING_PERIOD_START = 8;
   */ ContractDateType[ContractDateType["ORDERING_PERIOD_START"] = 8] = "ORDERING_PERIOD_START";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_ORDERING_PERIOD_END = 9;
   */ ContractDateType[ContractDateType["ORDERING_PERIOD_END"] = 9] = "ORDERING_PERIOD_END";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_TRANSITION = 10;
   */ ContractDateType[ContractDateType["TRANSITION"] = 10] = "TRANSITION";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_KICKOFF = 11;
   */ ContractDateType[ContractDateType["KICKOFF"] = 11] = "KICKOFF";
    /**
   * @generated from enum value: CONTRACT_DATE_TYPE_CLOSEOUT = 12;
   */ ContractDateType[ContractDateType["CLOSEOUT"] = 12] = "CLOSEOUT";
    /**
   * modification issued date (SF30)
   *
   * @generated from enum value: CONTRACT_DATE_TYPE_ISSUED = 13;
   */ ContractDateType[ContractDateType["ISSUED"] = 13] = "ISSUED";
    return ContractDateType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ContractDateType)
proto3.util.setEnumType(ContractDateType, "mono.contractintel.v1.ContractDateType", [
    {
        no: 0,
        name: "CONTRACT_DATE_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CONTRACT_DATE_TYPE_AWARD"
    },
    {
        no: 2,
        name: "CONTRACT_DATE_TYPE_EFFECTIVE"
    },
    {
        no: 3,
        name: "CONTRACT_DATE_TYPE_SIGNED"
    },
    {
        no: 4,
        name: "CONTRACT_DATE_TYPE_BASE_POP_START"
    },
    {
        no: 5,
        name: "CONTRACT_DATE_TYPE_BASE_POP_END"
    },
    {
        no: 6,
        name: "CONTRACT_DATE_TYPE_OPTION_POP_START"
    },
    {
        no: 7,
        name: "CONTRACT_DATE_TYPE_OPTION_POP_END"
    },
    {
        no: 8,
        name: "CONTRACT_DATE_TYPE_ORDERING_PERIOD_START"
    },
    {
        no: 9,
        name: "CONTRACT_DATE_TYPE_ORDERING_PERIOD_END"
    },
    {
        no: 10,
        name: "CONTRACT_DATE_TYPE_TRANSITION"
    },
    {
        no: 11,
        name: "CONTRACT_DATE_TYPE_KICKOFF"
    },
    {
        no: 12,
        name: "CONTRACT_DATE_TYPE_CLOSEOUT"
    },
    {
        no: 13,
        name: "CONTRACT_DATE_TYPE_ISSUED"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ObligationType
 */ export var ObligationType = /*#__PURE__*/ function(ObligationType) {
    /**
   * @generated from enum value: OBLIGATION_TYPE_UNSPECIFIED = 0;
   */ ObligationType[ObligationType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: OBLIGATION_TYPE_DELIVERABLE = 1;
   */ ObligationType[ObligationType["DELIVERABLE"] = 1] = "DELIVERABLE";
    /**
   * @generated from enum value: OBLIGATION_TYPE_PERFORMANCE = 2;
   */ ObligationType[ObligationType["PERFORMANCE"] = 2] = "PERFORMANCE";
    /**
   * @generated from enum value: OBLIGATION_TYPE_REPORTING = 3;
   */ ObligationType[ObligationType["REPORTING"] = 3] = "REPORTING";
    /**
   * @generated from enum value: OBLIGATION_TYPE_COMPLIANCE = 4;
   */ ObligationType[ObligationType["COMPLIANCE"] = 4] = "COMPLIANCE";
    /**
   * @generated from enum value: OBLIGATION_TYPE_MEETING = 5;
   */ ObligationType[ObligationType["MEETING"] = 5] = "MEETING";
    return ObligationType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ObligationType)
proto3.util.setEnumType(ObligationType, "mono.contractintel.v1.ObligationType", [
    {
        no: 0,
        name: "OBLIGATION_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "OBLIGATION_TYPE_DELIVERABLE"
    },
    {
        no: 2,
        name: "OBLIGATION_TYPE_PERFORMANCE"
    },
    {
        no: 3,
        name: "OBLIGATION_TYPE_REPORTING"
    },
    {
        no: 4,
        name: "OBLIGATION_TYPE_COMPLIANCE"
    },
    {
        no: 5,
        name: "OBLIGATION_TYPE_MEETING"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ObligationStrength
 */ export var ObligationStrength = /*#__PURE__*/ function(ObligationStrength) {
    /**
   * @generated from enum value: OBLIGATION_STRENGTH_UNSPECIFIED = 0;
   */ ObligationStrength[ObligationStrength["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * mandatory
   *
   * @generated from enum value: OBLIGATION_STRENGTH_SHALL = 1;
   */ ObligationStrength[ObligationStrength["SHALL"] = 1] = "SHALL";
    /**
   * @generated from enum value: OBLIGATION_STRENGTH_WILL = 2;
   */ ObligationStrength[ObligationStrength["WILL"] = 2] = "WILL";
    /**
   * advisory
   *
   * @generated from enum value: OBLIGATION_STRENGTH_SHOULD = 3;
   */ ObligationStrength[ObligationStrength["SHOULD"] = 3] = "SHOULD";
    /**
   * @generated from enum value: OBLIGATION_STRENGTH_MAY = 4;
   */ ObligationStrength[ObligationStrength["MAY"] = 4] = "MAY";
    return ObligationStrength;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ObligationStrength)
proto3.util.setEnumType(ObligationStrength, "mono.contractintel.v1.ObligationStrength", [
    {
        no: 0,
        name: "OBLIGATION_STRENGTH_UNSPECIFIED"
    },
    {
        no: 1,
        name: "OBLIGATION_STRENGTH_SHALL"
    },
    {
        no: 2,
        name: "OBLIGATION_STRENGTH_WILL"
    },
    {
        no: 3,
        name: "OBLIGATION_STRENGTH_SHOULD"
    },
    {
        no: 4,
        name: "OBLIGATION_STRENGTH_MAY"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ContractContactRole
 */ export var ContractContactRole = /*#__PURE__*/ function(ContractContactRole) {
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_UNSPECIFIED = 0;
   */ ContractContactRole[ContractContactRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_CONTRACTING_OFFICER = 1;
   */ ContractContactRole[ContractContactRole["CONTRACTING_OFFICER"] = 1] = "CONTRACTING_OFFICER";
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_CONTRACT_SPECIALIST = 2;
   */ ContractContactRole[ContractContactRole["CONTRACT_SPECIALIST"] = 2] = "CONTRACT_SPECIALIST";
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_COR = 3;
   */ ContractContactRole[ContractContactRole["COR"] = 3] = "COR";
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_PROGRAM_MANAGER = 4;
   */ ContractContactRole[ContractContactRole["PROGRAM_MANAGER"] = 4] = "PROGRAM_MANAGER";
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_TECHNICAL_POC = 5;
   */ ContractContactRole[ContractContactRole["TECHNICAL_POC"] = 5] = "TECHNICAL_POC";
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_OTHER = 6;
   */ ContractContactRole[ContractContactRole["OTHER"] = 6] = "OTHER";
    /**
   * @generated from enum value: CONTRACT_CONTACT_ROLE_CONTRACTOR = 7;
   */ ContractContactRole[ContractContactRole["CONTRACTOR"] = 7] = "CONTRACTOR";
    return ContractContactRole;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ContractContactRole)
proto3.util.setEnumType(ContractContactRole, "mono.contractintel.v1.ContractContactRole", [
    {
        no: 0,
        name: "CONTRACT_CONTACT_ROLE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "CONTRACT_CONTACT_ROLE_CONTRACTING_OFFICER"
    },
    {
        no: 2,
        name: "CONTRACT_CONTACT_ROLE_CONTRACT_SPECIALIST"
    },
    {
        no: 3,
        name: "CONTRACT_CONTACT_ROLE_COR"
    },
    {
        no: 4,
        name: "CONTRACT_CONTACT_ROLE_PROGRAM_MANAGER"
    },
    {
        no: 5,
        name: "CONTRACT_CONTACT_ROLE_TECHNICAL_POC"
    },
    {
        no: 6,
        name: "CONTRACT_CONTACT_ROLE_OTHER"
    },
    {
        no: 7,
        name: "CONTRACT_CONTACT_ROLE_CONTRACTOR"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ComplianceType
 */ export var ComplianceType = /*#__PURE__*/ function(ComplianceType) {
    /**
   * @generated from enum value: COMPLIANCE_TYPE_UNSPECIFIED = 0;
   */ ComplianceType[ComplianceType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: COMPLIANCE_TYPE_QASP = 1;
   */ ComplianceType[ComplianceType["QASP"] = 1] = "QASP";
    /**
   * @generated from enum value: COMPLIANCE_TYPE_CPARS = 2;
   */ ComplianceType[ComplianceType["CPARS"] = 2] = "CPARS";
    /**
   * @generated from enum value: COMPLIANCE_TYPE_AUDIT = 3;
   */ ComplianceType[ComplianceType["AUDIT"] = 3] = "AUDIT";
    /**
   * @generated from enum value: COMPLIANCE_TYPE_REPORT = 4;
   */ ComplianceType[ComplianceType["REPORT"] = 4] = "REPORT";
    /**
   * @generated from enum value: COMPLIANCE_TYPE_SECURITY = 5;
   */ ComplianceType[ComplianceType["SECURITY"] = 5] = "SECURITY";
    /**
   * @generated from enum value: COMPLIANCE_TYPE_DATA_RIGHTS = 6;
   */ ComplianceType[ComplianceType["DATA_RIGHTS"] = 6] = "DATA_RIGHTS";
    /**
   * @generated from enum value: COMPLIANCE_TYPE_CLOSEOUT = 7;
   */ ComplianceType[ComplianceType["CLOSEOUT"] = 7] = "CLOSEOUT";
    return ComplianceType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ComplianceType)
proto3.util.setEnumType(ComplianceType, "mono.contractintel.v1.ComplianceType", [
    {
        no: 0,
        name: "COMPLIANCE_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "COMPLIANCE_TYPE_QASP"
    },
    {
        no: 2,
        name: "COMPLIANCE_TYPE_CPARS"
    },
    {
        no: 3,
        name: "COMPLIANCE_TYPE_AUDIT"
    },
    {
        no: 4,
        name: "COMPLIANCE_TYPE_REPORT"
    },
    {
        no: 5,
        name: "COMPLIANCE_TYPE_SECURITY"
    },
    {
        no: 6,
        name: "COMPLIANCE_TYPE_DATA_RIGHTS"
    },
    {
        no: 7,
        name: "COMPLIANCE_TYPE_CLOSEOUT"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.FinancialTermType
 */ export var FinancialTermType = /*#__PURE__*/ function(FinancialTermType) {
    /**
   * @generated from enum value: FINANCIAL_TERM_TYPE_UNSPECIFIED = 0;
   */ FinancialTermType[FinancialTermType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: FINANCIAL_TERM_TYPE_FUNDING = 1;
   */ FinancialTermType[FinancialTermType["FUNDING"] = 1] = "FUNDING";
    /**
   * @generated from enum value: FINANCIAL_TERM_TYPE_INVOICING = 2;
   */ FinancialTermType[FinancialTermType["INVOICING"] = 2] = "INVOICING";
    /**
   * @generated from enum value: FINANCIAL_TERM_TYPE_PAYMENT_CADENCE = 3;
   */ FinancialTermType[FinancialTermType["PAYMENT_CADENCE"] = 3] = "PAYMENT_CADENCE";
    /**
   * @generated from enum value: FINANCIAL_TERM_TYPE_COST_CONTROL = 4;
   */ FinancialTermType[FinancialTermType["COST_CONTROL"] = 4] = "COST_CONTROL";
    /**
   * @generated from enum value: FINANCIAL_TERM_TYPE_OPTION_EXERCISE = 5;
   */ FinancialTermType[FinancialTermType["OPTION_EXERCISE"] = 5] = "OPTION_EXERCISE";
    return FinancialTermType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(FinancialTermType)
proto3.util.setEnumType(FinancialTermType, "mono.contractintel.v1.FinancialTermType", [
    {
        no: 0,
        name: "FINANCIAL_TERM_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "FINANCIAL_TERM_TYPE_FUNDING"
    },
    {
        no: 2,
        name: "FINANCIAL_TERM_TYPE_INVOICING"
    },
    {
        no: 3,
        name: "FINANCIAL_TERM_TYPE_PAYMENT_CADENCE"
    },
    {
        no: 4,
        name: "FINANCIAL_TERM_TYPE_COST_CONTROL"
    },
    {
        no: 5,
        name: "FINANCIAL_TERM_TYPE_OPTION_EXERCISE"
    }
]);
/**
 * Mirrors the canonical ContractChangeItem.diff_type set (spec §7.2).
 *
 * @generated from enum mono.contractintel.v1.DiffTypeV2
 */ export var DiffTypeV2 = /*#__PURE__*/ function(DiffTypeV2) {
    /**
   * @generated from enum value: DIFF_TYPE_V2_UNSPECIFIED = 0;
   */ DiffTypeV2[DiffTypeV2["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DIFF_TYPE_V2_FIELD = 1;
   */ DiffTypeV2[DiffTypeV2["FIELD"] = 1] = "FIELD";
    /**
   * @generated from enum value: DIFF_TYPE_V2_OBJECT = 2;
   */ DiffTypeV2[DiffTypeV2["OBJECT"] = 2] = "OBJECT";
    /**
   * @generated from enum value: DIFF_TYPE_V2_TEXT = 3;
   */ DiffTypeV2[DiffTypeV2["TEXT"] = 3] = "TEXT";
    /**
   * @generated from enum value: DIFF_TYPE_V2_CALENDAR = 4;
   */ DiffTypeV2[DiffTypeV2["CALENDAR"] = 4] = "CALENDAR";
    /**
   * @generated from enum value: DIFF_TYPE_V2_FINANCIAL = 5;
   */ DiffTypeV2[DiffTypeV2["FINANCIAL"] = 5] = "FINANCIAL";
    /**
   * @generated from enum value: DIFF_TYPE_V2_EVIDENCE = 6;
   */ DiffTypeV2[DiffTypeV2["EVIDENCE"] = 6] = "EVIDENCE";
    /**
   * @generated from enum value: DIFF_TYPE_V2_AUTHORITY = 7;
   */ DiffTypeV2[DiffTypeV2["AUTHORITY"] = 7] = "AUTHORITY";
    return DiffTypeV2;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DiffTypeV2)
proto3.util.setEnumType(DiffTypeV2, "mono.contractintel.v1.DiffTypeV2", [
    {
        no: 0,
        name: "DIFF_TYPE_V2_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DIFF_TYPE_V2_FIELD"
    },
    {
        no: 2,
        name: "DIFF_TYPE_V2_OBJECT"
    },
    {
        no: 3,
        name: "DIFF_TYPE_V2_TEXT"
    },
    {
        no: 4,
        name: "DIFF_TYPE_V2_CALENDAR"
    },
    {
        no: 5,
        name: "DIFF_TYPE_V2_FINANCIAL"
    },
    {
        no: 6,
        name: "DIFF_TYPE_V2_EVIDENCE"
    },
    {
        no: 7,
        name: "DIFF_TYPE_V2_AUTHORITY"
    }
]);
/**
 * Mirrors the canonical ContractChangeItem.change_category set.
 *
 * @generated from enum mono.contractintel.v1.ModChangeCategory
 */ export var ModChangeCategory = /*#__PURE__*/ function(ModChangeCategory) {
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_UNSPECIFIED = 0;
   */ ModChangeCategory[ModChangeCategory["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_SCOPE = 1;
   */ ModChangeCategory[ModChangeCategory["SCOPE"] = 1] = "SCOPE";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_FUNDING = 2;
   */ ModChangeCategory[ModChangeCategory["FUNDING"] = 2] = "FUNDING";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_PERIOD = 3;
   */ ModChangeCategory[ModChangeCategory["PERIOD"] = 3] = "PERIOD";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_OPTION = 4;
   */ ModChangeCategory[ModChangeCategory["OPTION"] = 4] = "OPTION";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_DELIVERABLE = 5;
   */ ModChangeCategory[ModChangeCategory["DELIVERABLE"] = 5] = "DELIVERABLE";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_POC = 6;
   */ ModChangeCategory[ModChangeCategory["POC"] = 6] = "POC";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_STAFFING = 7;
   */ ModChangeCategory[ModChangeCategory["STAFFING"] = 7] = "STAFFING";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_SUBCONTRACT = 8;
   */ ModChangeCategory[ModChangeCategory["SUBCONTRACT"] = 8] = "SUBCONTRACT";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_COMPLIANCE = 9;
   */ ModChangeCategory[ModChangeCategory["COMPLIANCE"] = 9] = "COMPLIANCE";
    /**
   * @generated from enum value: MOD_CHANGE_CATEGORY_ADMIN = 10;
   */ ModChangeCategory[ModChangeCategory["ADMIN"] = 10] = "ADMIN";
    return ModChangeCategory;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ModChangeCategory)
proto3.util.setEnumType(ModChangeCategory, "mono.contractintel.v1.ModChangeCategory", [
    {
        no: 0,
        name: "MOD_CHANGE_CATEGORY_UNSPECIFIED"
    },
    {
        no: 1,
        name: "MOD_CHANGE_CATEGORY_SCOPE"
    },
    {
        no: 2,
        name: "MOD_CHANGE_CATEGORY_FUNDING"
    },
    {
        no: 3,
        name: "MOD_CHANGE_CATEGORY_PERIOD"
    },
    {
        no: 4,
        name: "MOD_CHANGE_CATEGORY_OPTION"
    },
    {
        no: 5,
        name: "MOD_CHANGE_CATEGORY_DELIVERABLE"
    },
    {
        no: 6,
        name: "MOD_CHANGE_CATEGORY_POC"
    },
    {
        no: 7,
        name: "MOD_CHANGE_CATEGORY_STAFFING"
    },
    {
        no: 8,
        name: "MOD_CHANGE_CATEGORY_SUBCONTRACT"
    },
    {
        no: 9,
        name: "MOD_CHANGE_CATEGORY_COMPLIANCE"
    },
    {
        no: 10,
        name: "MOD_CHANGE_CATEGORY_ADMIN"
    }
]);
/**
 * @generated from enum mono.contractintel.v1.ModificationClassification
 */ export var ModificationClassification = /*#__PURE__*/ function(ModificationClassification) {
    /**
   * @generated from enum value: MODIFICATION_CLASSIFICATION_UNSPECIFIED = 0;
   */ ModificationClassification[ModificationClassification["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: MODIFICATION_CLASSIFICATION_BILATERAL = 1;
   */ ModificationClassification[ModificationClassification["BILATERAL"] = 1] = "BILATERAL";
    /**
   * @generated from enum value: MODIFICATION_CLASSIFICATION_UNILATERAL = 2;
   */ ModificationClassification[ModificationClassification["UNILATERAL"] = 2] = "UNILATERAL";
    /**
   * @generated from enum value: MODIFICATION_CLASSIFICATION_ADMINISTRATIVE = 3;
   */ ModificationClassification[ModificationClassification["ADMINISTRATIVE"] = 3] = "ADMINISTRATIVE";
    /**
   * @generated from enum value: MODIFICATION_CLASSIFICATION_CHANGE_ORDER = 4;
   */ ModificationClassification[ModificationClassification["CHANGE_ORDER"] = 4] = "CHANGE_ORDER";
    /**
   * @generated from enum value: MODIFICATION_CLASSIFICATION_SUPPLEMENTAL = 5;
   */ ModificationClassification[ModificationClassification["SUPPLEMENTAL"] = 5] = "SUPPLEMENTAL";
    return ModificationClassification;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ModificationClassification)
proto3.util.setEnumType(ModificationClassification, "mono.contractintel.v1.ModificationClassification", [
    {
        no: 0,
        name: "MODIFICATION_CLASSIFICATION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "MODIFICATION_CLASSIFICATION_BILATERAL"
    },
    {
        no: 2,
        name: "MODIFICATION_CLASSIFICATION_UNILATERAL"
    },
    {
        no: 3,
        name: "MODIFICATION_CLASSIFICATION_ADMINISTRATIVE"
    },
    {
        no: 4,
        name: "MODIFICATION_CLASSIFICATION_CHANGE_ORDER"
    },
    {
        no: 5,
        name: "MODIFICATION_CLASSIFICATION_SUPPLEMENTAL"
    }
]);
/**
 * @generated from message mono.contractintel.v1.AddressInfo
 */ export class AddressInfo extends Message {
    static fromBinary(bytes, options) {
        return new AddressInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string street1 = 1;
   */ _define_property(this, "street1", ""), /**
   * @generated from field: string street2 = 2;
   */ _define_property(this, "street2", ""), /**
   * @generated from field: string city = 3;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 5;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 6;
   */ _define_property(this, "country", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddressInfo, "runtime", proto3);
_define_property(AddressInfo, "typeName", "mono.contractintel.v1.AddressInfo");
_define_property(AddressInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "street1",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "street2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.AgencyInfo
 */ export class AgencyInfo extends Message {
    static fromBinary(bytes, options) {
        return new AgencyInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AgencyInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AgencyInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AgencyInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string acronym = 2;
   */ _define_property(this, "acronym", ""), /**
   * @generated from field: string sub_agency = 3;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string sub_agency_acronym = 4;
   */ _define_property(this, "subAgencyAcronym", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AgencyInfo, "runtime", proto3);
_define_property(AgencyInfo, "typeName", "mono.contractintel.v1.AgencyInfo");
_define_property(AgencyInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sub_agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractVehicle
 */ export class ContractVehicle extends Message {
    static fromBinary(bytes, options) {
        return new ContractVehicle().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractVehicle().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractVehicle().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractVehicle, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string contract_number = 2;
   */ _define_property(this, "contractNumber", ""), /**
   * GSA_SCHEDULE, GWAC, BPA, IDIQ, OTHER
   *
   * @generated from field: string vehicle_type = 3;
   */ _define_property(this, "vehicleType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractVehicle, "runtime", proto3);
_define_property(ContractVehicle, "typeName", "mono.contractintel.v1.ContractVehicle");
_define_property(ContractVehicle, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractorInfo
 */ export class ContractorInfo extends Message {
    static fromBinary(bytes, options) {
        return new ContractorInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractorInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractorInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractorInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string duns = 2;
   */ _define_property(this, "duns", ""), /**
   * @generated from field: string uei = 3;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage_code = 4;
   */ _define_property(this, "cageCode", ""), /**
   * @generated from field: mono.contractintel.v1.AddressInfo address = 5;
   */ _define_property(this, "address", void 0), /**
   * prime, subcontractor, teaming_partner
   *
   * @generated from field: string role = 6;
   */ _define_property(this, "role", ""), /**
   * @generated from field: double percentage = 7;
   */ _define_property(this, "percentage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractorInfo, "runtime", proto3);
_define_property(ContractorInfo, "typeName", "mono.contractintel.v1.ContractorInfo");
_define_property(ContractorInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "address",
            kind: "message",
            T: AddressInfo
        },
        {
            no: 6,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GovernmentContact
 */ export class GovernmentContact extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentContact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentContact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentContact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentContact, a, b);
    }
    constructor(data){
        super(), /**
   * contracting_officer, cor, technical_poc, program_manager, other
   *
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 4;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 5;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string organization = 6;
   */ _define_property(this, "organization", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentContact, "runtime", proto3);
_define_property(GovernmentContact, "typeName", "mono.contractintel.v1.GovernmentContact");
_define_property(GovernmentContact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PlaceOfPerformance
 */ export class PlaceOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new PlaceOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool primary = 1;
   */ _define_property(this, "primary", false), /**
   * @generated from field: mono.contractintel.v1.AddressInfo location = 2;
   */ _define_property(this, "location", void 0), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double percentage = 4;
   */ _define_property(this, "percentage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlaceOfPerformance, "runtime", proto3);
_define_property(PlaceOfPerformance, "typeName", "mono.contractintel.v1.PlaceOfPerformance");
_define_property(PlaceOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "location",
            kind: "message",
            T: AddressInfo
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PeriodInfo
 */ export class PeriodInfo extends Message {
    static fromBinary(bytes, options) {
        return new PeriodInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: int32 duration_months = 4;
   */ _define_property(this, "durationMonths", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodInfo, "runtime", proto3);
_define_property(PeriodInfo, "typeName", "mono.contractintel.v1.PeriodInfo");
_define_property(PeriodInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PeriodOfPerformance
 */ export class PeriodOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new PeriodOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: int32 duration_months = 3;
   */ _define_property(this, "durationMonths", 0), /**
   * @generated from field: mono.contractintel.v1.PeriodInfo base_period = 4;
   */ _define_property(this, "basePeriod", void 0), /**
   * @generated from field: repeated mono.contractintel.v1.PeriodInfo option_periods = 5;
   */ _define_property(this, "optionPeriods", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodOfPerformance, "runtime", proto3);
_define_property(PeriodOfPerformance, "typeName", "mono.contractintel.v1.PeriodOfPerformance");
_define_property(PeriodOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "base_period",
            kind: "message",
            T: PeriodInfo
        },
        {
            no: 5,
            name: "option_periods",
            kind: "message",
            T: PeriodInfo,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractValue
 */ export class ContractValue extends Message {
    static fromBinary(bytes, options) {
        return new ContractValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractValue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double base_value = 1;
   */ _define_property(this, "baseValue", 0), /**
   * @generated from field: double total_ceiling = 2;
   */ _define_property(this, "totalCeiling", 0), /**
   * @generated from field: string currency = 3;
   */ _define_property(this, "currency", ""), /**
   * Printed schedule total, potentially including unexercised options. This
   * is neither a funding assertion nor an independently stated ceiling.
   *
   * @generated from field: optional double scheduled_value = 4;
   */ _define_property(this, "scheduledValue", void 0), /**
   * Cover/current award amount; preserves administrative zero as distinct
   * from an absent or redacted value. It does not by itself prove obligation.
   *
   * @generated from field: optional double current_award_amount = 5;
   */ _define_property(this, "currentAwardAmount", void 0), /**
   * @generated from field: optional double minimum_guarantee = 6;
   */ _define_property(this, "minimumGuarantee", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractValue, "runtime", proto3);
_define_property(ContractValue, "typeName", "mono.contractintel.v1.ContractValue");
_define_property(ContractValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "base_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "total_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scheduled_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 5,
            name: "current_award_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 6,
            name: "minimum_guarantee",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractSummary
 */ export class ContractSummary extends Message {
    static fromBinary(bytes, options) {
        return new ContractSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSummary, a, b);
    }
    constructor(data){
        super(), /**
   * Legacy summary field. Reports unique CLIN numbers.
   *
   * @generated from field: int32 total_clins = 1;
   */ _define_property(this, "totalClins", 0), /**
   * @generated from field: int32 total_deliverables = 2;
   */ _define_property(this, "totalDeliverables", 0), /**
   * @generated from field: double total_contract_value = 3;
   */ _define_property(this, "totalContractValue", 0), /**
   * @generated from field: double base_value = 4;
   */ _define_property(this, "baseValue", 0), /**
   * @generated from field: double options_value = 5;
   */ _define_property(this, "optionsValue", 0), /**
   * @generated from field: repeated mono.contractintel.v1.PeriodSummary periods = 6;
   */ _define_property(this, "periods", []), /**
   * @generated from field: int32 unique_clin_numbers = 7;
   */ _define_property(this, "uniqueClinNumbers", 0), /**
   * @generated from field: int32 unique_clin_period_entries = 8;
   */ _define_property(this, "uniqueClinPeriodEntries", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSummary, "runtime", proto3);
_define_property(ContractSummary, "typeName", "mono.contractintel.v1.ContractSummary");
_define_property(ContractSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_clins",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_deliverables",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "base_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "options_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "periods",
            kind: "message",
            T: PeriodSummary,
            repeated: true
        },
        {
            no: 7,
            name: "unique_clin_numbers",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "unique_clin_period_entries",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PeriodSummary
 */ export class PeriodSummary extends Message {
    static fromBinary(bytes, options) {
        return new PeriodSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.contractintel.v1.CLINOptionType type = 2;
   */ _define_property(this, "type", 0), /**
   * @generated from field: int32 option_number = 3;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: string start_date = 4;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 5;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: double total_value = 6;
   */ _define_property(this, "totalValue", 0), /**
   * @generated from field: double funded_value = 7;
   */ _define_property(this, "fundedValue", 0), /**
   * @generated from field: int32 clin_count = 8;
   */ _define_property(this, "clinCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodSummary, "runtime", proto3);
_define_property(PeriodSummary, "typeName", "mono.contractintel.v1.PeriodSummary");
_define_property(PeriodSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(CLINOptionType)
        },
        {
            no: 3,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "funded_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "clin_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ConfidenceScores
 */ export class ConfidenceScores extends Message {
    static fromBinary(bytes, options) {
        return new ConfidenceScores().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfidenceScores().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfidenceScores().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfidenceScores, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double table_detection = 1;
   */ _define_property(this, "tableDetection", 0), /**
   * @generated from field: double enrichment = 2;
   */ _define_property(this, "enrichment", 0), /**
   * @generated from field: double overall = 3;
   */ _define_property(this, "overall", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConfidenceScores, "runtime", proto3);
_define_property(ConfidenceScores, "typeName", "mono.contractintel.v1.ConfidenceScores");
_define_property(ConfidenceScores, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "table_detection",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "enrichment",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "overall",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * Full contract analysis entity.
 *
 * @generated from message mono.contractintel.v1.ContractAnalysis
 */ export class ContractAnalysis extends Message {
    static fromBinary(bytes, options) {
        return new ContractAnalysis().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractAnalysis().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractAnalysis().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractAnalysis, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string contract_number = 2;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string organization_id = 4;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: string source_file_id = 5;
   */ _define_property(this, "sourceFileId", ""), /**
   * @generated from field: string chat_id = 6;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string user_id = 7;
   */ _define_property(this, "userId", ""), /**
   * Header
   *
   * @generated from field: string contract_title = 10;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: mono.contractintel.v1.ContractType contract_type = 11;
   */ _define_property(this, "contractType", 0), /**
   * @generated from field: string solicitation_number = 12;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: mono.contractintel.v1.AgencyInfo agency = 13;
   */ _define_property(this, "agency", void 0), /**
   * @generated from field: mono.contractintel.v1.ContractVehicle contracting_vehicle = 14;
   */ _define_property(this, "contractingVehicle", void 0), /**
   * @generated from field: google.protobuf.Timestamp award_date = 15;
   */ _define_property(this, "awardDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 16;
   */ _define_property(this, "effectiveDate", void 0), /**
   * Parties
   *
   * @generated from field: mono.contractintel.v1.ContractorInfo prime_contractor = 20;
   */ _define_property(this, "primeContractor", void 0), /**
   * @generated from field: repeated mono.contractintel.v1.ContractorInfo subcontractors = 21;
   */ _define_property(this, "subcontractors", []), /**
   * @generated from field: repeated mono.contractintel.v1.GovernmentContact government_contacts = 22;
   */ _define_property(this, "governmentContacts", []), /**
   * @generated from field: repeated mono.contractintel.v1.PlaceOfPerformance places_of_performance = 23;
   */ _define_property(this, "placesOfPerformance", []), /**
   * Period & value
   *
   * @generated from field: mono.contractintel.v1.PeriodOfPerformance period_of_performance = 30;
   */ _define_property(this, "periodOfPerformance", void 0), /**
   * @generated from field: mono.contractintel.v1.ContractValue total_value = 31;
   */ _define_property(this, "totalValue", void 0), /**
   * @generated from field: mono.contractintel.v1.ContractSummary summary = 32;
   */ _define_property(this, "summary", void 0), /**
   * Metadata
   *
   * @generated from field: mono.contractintel.v1.ConfidenceScores confidence = 40;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: google.protobuf.Timestamp extraction_date = 41;
   */ _define_property(this, "extractionDate", void 0), /**
   * @generated from field: string extraction_version = 42;
   */ _define_property(this, "extractionVersion", ""), /**
   * @generated from field: repeated string extraction_notes = 43;
   */ _define_property(this, "extractionNotes", []), /**
   * @generated from field: mono.contractintel.v1.ContractAnalysisStatus status = 44;
   */ _define_property(this, "status", 0), /**
   * @generated from field: string error_message = 45;
   */ _define_property(this, "errorMessage", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 50;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 51;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractAnalysis, "runtime", proto3);
_define_property(ContractAnalysis, "typeName", "mono.contractintel.v1.ContractAnalysis");
_define_property(ContractAnalysis, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "contract_type",
            kind: "enum",
            T: proto3.getEnumType(ContractType)
        },
        {
            no: 12,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "agency",
            kind: "message",
            T: AgencyInfo
        },
        {
            no: 14,
            name: "contracting_vehicle",
            kind: "message",
            T: ContractVehicle
        },
        {
            no: 15,
            name: "award_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "prime_contractor",
            kind: "message",
            T: ContractorInfo
        },
        {
            no: 21,
            name: "subcontractors",
            kind: "message",
            T: ContractorInfo,
            repeated: true
        },
        {
            no: 22,
            name: "government_contacts",
            kind: "message",
            T: GovernmentContact,
            repeated: true
        },
        {
            no: 23,
            name: "places_of_performance",
            kind: "message",
            T: PlaceOfPerformance,
            repeated: true
        },
        {
            no: 30,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        },
        {
            no: 31,
            name: "total_value",
            kind: "message",
            T: ContractValue
        },
        {
            no: 32,
            name: "summary",
            kind: "message",
            T: ContractSummary
        },
        {
            no: 40,
            name: "confidence",
            kind: "message",
            T: ConfidenceScores
        },
        {
            no: 41,
            name: "extraction_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 42,
            name: "extraction_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "extraction_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 44,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ContractAnalysisStatus)
        },
        {
            no: 45,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 50,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 51,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.CLINPricing
 */ export class CLINPricing extends Message {
    static fromBinary(bytes, options) {
        return new CLINPricing().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINPricing().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINPricing().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINPricing, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double unit_price = 1;
   */ _define_property(this, "unitPrice", 0), /**
   * @generated from field: double extended_price = 2;
   */ _define_property(this, "extendedPrice", 0), /**
   * @generated from field: bool is_nsp = 3;
   */ _define_property(this, "isNsp", false), /**
   * @generated from field: bool is_nte = 4;
   */ _define_property(this, "isNte", false), /**
   * @generated from field: double nte_ceiling = 5;
   */ _define_property(this, "nteCeiling", 0), /**
   * @generated from field: double funded_amount = 6;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double unfunded_amount = 7;
   */ _define_property(this, "unfundedAmount", 0), /**
   * @generated from field: double handling_rate = 8;
   */ _define_property(this, "handlingRate", 0), /**
   * @generated from field: double award_amount = 9;
   */ _define_property(this, "awardAmount", 0), /**
   * @generated from field: double invoiced_amount = 10;
   */ _define_property(this, "invoicedAmount", 0), /**
   * @generated from field: double paid_amount = 11;
   */ _define_property(this, "paidAmount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINPricing, "runtime", proto3);
_define_property(CLINPricing, "typeName", "mono.contractintel.v1.CLINPricing");
_define_property(CLINPricing, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "extended_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "is_nsp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "is_nte",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "handling_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "award_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "invoiced_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "paid_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.LaborCategory
 */ export class LaborCategory extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: double rate = 2;
   */ _define_property(this, "rate", 0), /**
   * @generated from field: double estimated_hours = 3;
   */ _define_property(this, "estimatedHours", 0), /**
   * @generated from field: double estimated_cost = 4;
   */ _define_property(this, "estimatedCost", 0), /**
   * @generated from field: string hours_basis = 5;
   */ _define_property(this, "hoursBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategory, "runtime", proto3);
_define_property(LaborCategory, "typeName", "mono.contractintel.v1.LaborCategory");
_define_property(LaborCategory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "estimated_hours",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "estimated_cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "hours_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.LaborMix
 */ export class LaborMix extends Message {
    static fromBinary(bytes, options) {
        return new LaborMix().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborMix().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborMix().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborMix, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.contractintel.v1.LaborCategory categories = 1;
   */ _define_property(this, "categories", []), /**
   * @generated from field: double iteration_price = 2;
   */ _define_property(this, "iterationPrice", 0), /**
   * @generated from field: int32 max_iterations = 3;
   */ _define_property(this, "maxIterations", 0), /**
   * @generated from field: string notes = 4;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborMix, "runtime", proto3);
_define_property(LaborMix, "typeName", "mono.contractintel.v1.LaborMix");
_define_property(LaborMix, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "categories",
            kind: "message",
            T: LaborCategory,
            repeated: true
        },
        {
            no: 2,
            name: "iteration_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "max_iterations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.DeliverableSchedule
 */ export class DeliverableSchedule extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableSchedule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableSchedule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableSchedule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableSchedule, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string initial_due_date = 1;
   */ _define_property(this, "initialDueDate", ""), /**
   * @generated from field: int32 days_after_award = 2;
   */ _define_property(this, "daysAfterAward", 0), /**
   * @generated from field: string cadence = 3;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: string trigger_event = 4;
   */ _define_property(this, "triggerEvent", ""), /**
   * @generated from field: string recurring_detail = 5;
   */ _define_property(this, "recurringDetail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableSchedule, "runtime", proto3);
_define_property(DeliverableSchedule, "typeName", "mono.contractintel.v1.DeliverableSchedule");
_define_property(DeliverableSchedule, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "initial_due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "days_after_award",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "trigger_event",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "recurring_detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.InlineDeliverable
 */ export class InlineDeliverable extends Message {
    static fromBinary(bytes, options) {
        return new InlineDeliverable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InlineDeliverable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InlineDeliverable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InlineDeliverable, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.contractintel.v1.DeliverableSchedule schedule = 2;
   */ _define_property(this, "schedule", void 0), /**
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: repeated string pws_sections = 4;
   */ _define_property(this, "pwsSections", []), /**
   * @generated from field: string format = 5;
   */ _define_property(this, "format", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(InlineDeliverable, "runtime", proto3);
_define_property(InlineDeliverable, "typeName", "mono.contractintel.v1.InlineDeliverable");
_define_property(InlineDeliverable, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "schedule",
            kind: "message",
            T: DeliverableSchedule
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.FundingHistoryEntry
 */ export class FundingHistoryEntry extends Message {
    static fromBinary(bytes, options) {
        return new FundingHistoryEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingHistoryEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingHistoryEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingHistoryEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string modification_id = 1;
   */ _define_property(this, "modificationId", ""), /**
   * @generated from field: string modification_number = 2;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 3;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: double previous_funded_amount = 4;
   */ _define_property(this, "previousFundedAmount", 0), /**
   * @generated from field: double previous_unfunded_amount = 5;
   */ _define_property(this, "previousUnfundedAmount", 0), /**
   * @generated from field: double change_amount = 6;
   */ _define_property(this, "changeAmount", 0), /**
   * @generated from field: double new_funded_amount = 7;
   */ _define_property(this, "newFundedAmount", 0), /**
   * @generated from field: double new_unfunded_amount = 8;
   */ _define_property(this, "newUnfundedAmount", 0), /**
   * @generated from field: string change_reason = 9;
   */ _define_property(this, "changeReason", ""), /**
   * @generated from field: google.protobuf.Timestamp recorded_at = 10;
   */ _define_property(this, "recordedAt", void 0), /**
   * @generated from field: string recorded_by = 11;
   */ _define_property(this, "recordedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FundingHistoryEntry, "runtime", proto3);
_define_property(FundingHistoryEntry, "typeName", "mono.contractintel.v1.FundingHistoryEntry");
_define_property(FundingHistoryEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "previous_funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "previous_unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "change_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "new_funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "new_unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "change_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "recorded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.CLINPeriodOfPerformance
 */ export class CLINPeriodOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new CLINPeriodOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CLINPeriodOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CLINPeriodOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CLINPeriodOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string start_date = 1;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 2;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: int32 duration_months = 3;
   */ _define_property(this, "durationMonths", 0), /**
   * @generated from field: string period_name = 4;
   */ _define_property(this, "periodName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CLINPeriodOfPerformance, "runtime", proto3);
_define_property(CLINPeriodOfPerformance, "typeName", "mono.contractintel.v1.CLINPeriodOfPerformance");
_define_property(CLINPeriodOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Full CLIN entity.
 *
 * @generated from message mono.contractintel.v1.ContractCLIN
 */ export class ContractCLIN extends Message {
    static fromBinary(bytes, options) {
        return new ContractCLIN().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractCLIN().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractCLIN().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractCLIN, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string organization_id = 4;
   */ _define_property(this, "organizationId", ""), /**
   * Identification
   *
   * @generated from field: string clin_number = 10;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin = 11;
   */ _define_property(this, "parentClin", ""), /**
   * @generated from field: bool is_subline_item = 12;
   */ _define_property(this, "isSublineItem", false), /**
   * @generated from field: mono.contractintel.v1.SublineType subline_type = 13;
   */ _define_property(this, "sublineType", 0), /**
   * Classification
   *
   * @generated from field: mono.contractintel.v1.CLINOptionType option_type = 20;
   */ _define_property(this, "optionType", 0), /**
   * @generated from field: int32 option_period_number = 21;
   */ _define_property(this, "optionPeriodNumber", 0), /**
   * @generated from field: mono.contractintel.v1.CLINContractType contract_type = 22;
   */ _define_property(this, "contractType", 0), /**
   * Description
   *
   * @generated from field: string description = 30;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string short_title = 31;
   */ _define_property(this, "shortTitle", ""), /**
   * @generated from field: repeated string pws_sections = 32;
   */ _define_property(this, "pwsSections", []), /**
   * Quantity & Pricing
   *
   * @generated from field: double quantity = 40;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: string unit = 41;
   */ _define_property(this, "unit", ""), /**
   * @generated from field: mono.contractintel.v1.CLINPricing pricing = 42;
   */ _define_property(this, "pricing", void 0), /**
   * Period of Performance
   *
   * @generated from field: mono.contractintel.v1.CLINPeriodOfPerformance period_of_performance = 50;
   */ _define_property(this, "periodOfPerformance", void 0), /**
   * Deliverables
   *
   * @generated from field: bool has_deliverables = 60;
   */ _define_property(this, "hasDeliverables", false), /**
   * @generated from field: repeated mono.contractintel.v1.InlineDeliverable deliverables = 61;
   */ _define_property(this, "deliverables", []), /**
   * Labor Mix
   *
   * @generated from field: bool has_labor_mix = 70;
   */ _define_property(this, "hasLaborMix", false), /**
   * @generated from field: mono.contractintel.v1.LaborMix labor_mix = 71;
   */ _define_property(this, "laborMix", void 0), /**
   * Funding
   *
   * @generated from field: mono.contractintel.v1.FundingStatus funding_status = 80;
   */ _define_property(this, "fundingStatus", 0), /**
   * @generated from field: repeated mono.contractintel.v1.FundingHistoryEntry funding_history = 81;
   */ _define_property(this, "fundingHistory", []), /**
   * Cross-period
   *
   * @generated from field: string corresponding_base_clin = 90;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * @generated from field: int32 sort_order = 91;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 100;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 101;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractCLIN, "runtime", proto3);
_define_property(ContractCLIN, "typeName", "mono.contractintel.v1.ContractCLIN");
_define_property(ContractCLIN, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "parent_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "is_subline_item",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "subline_type",
            kind: "enum",
            T: proto3.getEnumType(SublineType)
        },
        {
            no: 20,
            name: "option_type",
            kind: "enum",
            T: proto3.getEnumType(CLINOptionType)
        },
        {
            no: 21,
            name: "option_period_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 22,
            name: "contract_type",
            kind: "enum",
            T: proto3.getEnumType(CLINContractType)
        },
        {
            no: 30,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "short_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 40,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 41,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 42,
            name: "pricing",
            kind: "message",
            T: CLINPricing
        },
        {
            no: 50,
            name: "period_of_performance",
            kind: "message",
            T: CLINPeriodOfPerformance
        },
        {
            no: 60,
            name: "has_deliverables",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 61,
            name: "deliverables",
            kind: "message",
            T: InlineDeliverable,
            repeated: true
        },
        {
            no: 70,
            name: "has_labor_mix",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 71,
            name: "labor_mix",
            kind: "message",
            T: LaborMix
        },
        {
            no: 80,
            name: "funding_status",
            kind: "enum",
            T: proto3.getEnumType(FundingStatus)
        },
        {
            no: 81,
            name: "funding_history",
            kind: "message",
            T: FundingHistoryEntry,
            repeated: true
        },
        {
            no: 90,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 91,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 100,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 101,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractDeliverable
 */ export class ContractDeliverable extends Message {
    static fromBinary(bytes, options) {
        return new ContractDeliverable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractDeliverable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractDeliverable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractDeliverable, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string clin_id = 4;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string clin_number = 5;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string organization_id = 6;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: string deliverable_id = 10;
   */ _define_property(this, "deliverableId", ""), /**
   * @generated from field: string name = 11;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 12;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated string pws_sections = 13;
   */ _define_property(this, "pwsSections", []), /**
   * @generated from field: mono.contractintel.v1.DeliverableSchedule schedule = 14;
   */ _define_property(this, "schedule", void 0), /**
   * @generated from field: string slin_number = 15;
   */ _define_property(this, "slinNumber", ""), /**
   * @generated from field: string format = 16;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 17;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 18;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: bool is_cdrl = 19;
   */ _define_property(this, "isCdrl", false), /**
   * @generated from field: string cdrl_number = 20;
   */ _define_property(this, "cdrlNumber", ""), /**
   * @generated from field: mono.contractintel.v1.DeliverableType type = 21;
   */ _define_property(this, "type", 0), /**
   * @generated from field: string status = 22;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 sort_order = 23;
   */ _define_property(this, "sortOrder", 0), /**
   * Submission tracking
   *
   * @generated from field: int32 total_submissions = 24;
   */ _define_property(this, "totalSubmissions", 0), /**
   * @generated from field: int32 accepted_submissions = 25;
   */ _define_property(this, "acceptedSubmissions", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 30;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 31;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractDeliverable, "runtime", proto3);
_define_property(ContractDeliverable, "typeName", "mono.contractintel.v1.ContractDeliverable");
_define_property(ContractDeliverable, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "schedule",
            kind: "message",
            T: DeliverableSchedule
        },
        {
            no: 15,
            name: "slin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "is_cdrl",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "cdrl_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(DeliverableType)
        },
        {
            no: 22,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 24,
            name: "total_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 25,
            name: "accepted_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 30,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.DeliverableSubmission
 */ export class DeliverableSubmission extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableSubmission().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableSubmission().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableSubmission().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableSubmission, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string deliverable_id = 2;
   */ _define_property(this, "deliverableId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string submitted_by = 4;
   */ _define_property(this, "submittedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 5;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: string storage_path = 6;
   */ _define_property(this, "storagePath", ""), /**
   * @generated from field: string filename = 7;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 8;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 file_size = 9;
   */ _define_property(this, "fileSize", protoInt64.zero), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * submitted, under_review, accepted, rejected
   *
   * @generated from field: string status = 11;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string feedback = 12;
   */ _define_property(this, "feedback", ""), /**
   * @generated from field: string reviewed_by = 13;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 14;
   */ _define_property(this, "reviewedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableSubmission, "runtime", proto3);
_define_property(DeliverableSubmission, "typeName", "mono.contractintel.v1.DeliverableSubmission");
_define_property(DeliverableSubmission, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "submitted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "storage_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "file_size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "feedback",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.FundingChange
 */ export class FundingChange extends Message {
    static fromBinary(bytes, options) {
        return new FundingChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * addition, deduction, deobligation
   *
   * @generated from field: string change_type = 2;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: double previous_amount = 4;
   */ _define_property(this, "previousAmount", 0), /**
   * @generated from field: double new_amount = 5;
   */ _define_property(this, "newAmount", 0), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FundingChange, "runtime", proto3);
_define_property(FundingChange, "typeName", "mono.contractintel.v1.FundingChange");
_define_property(FundingChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "previous_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "new_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ScopeChange
 */ export class ScopeChange extends Message {
    static fromBinary(bytes, options) {
        return new ScopeChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScopeChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScopeChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScopeChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * added, removed, modified
   *
   * @generated from field: string change_type = 2;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: repeated string pws_sections = 4;
   */ _define_property(this, "pwsSections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScopeChange, "runtime", proto3);
_define_property(ScopeChange, "typeName", "mono.contractintel.v1.ScopeChange");
_define_property(ScopeChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PeriodChange
 */ export class PeriodChange extends Message {
    static fromBinary(bytes, options) {
        return new PeriodChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodChange, a, b);
    }
    constructor(data){
        super(), /**
   * extension, option_exercise, reduction
   *
   * @generated from field: string change_type = 1;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: google.protobuf.Timestamp previous_end_date = 2;
   */ _define_property(this, "previousEndDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp new_end_date = 3;
   */ _define_property(this, "newEndDate", void 0), /**
   * @generated from field: int32 option_period = 4;
   */ _define_property(this, "optionPeriod", 0), /**
   * @generated from field: repeated string clin_numbers = 5;
   */ _define_property(this, "clinNumbers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodChange, "runtime", proto3);
_define_property(PeriodChange, "typeName", "mono.contractintel.v1.PeriodChange");
_define_property(PeriodChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "previous_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "new_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "option_period",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "clin_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PersonnelChange
 */ export class PersonnelChange extends Message {
    static fromBinary(bytes, options) {
        return new PersonnelChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PersonnelChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PersonnelChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PersonnelChange, a, b);
    }
    constructor(data){
        super(), /**
   * substitution, addition, removal
   *
   * @generated from field: string change_type = 1;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string position = 2;
   */ _define_property(this, "position", ""), /**
   * @generated from field: string previous_person = 3;
   */ _define_property(this, "previousPerson", ""), /**
   * @generated from field: string new_person = 4;
   */ _define_property(this, "newPerson", ""), /**
   * @generated from field: string approval_status = 5;
   */ _define_property(this, "approvalStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PersonnelChange, "runtime", proto3);
_define_property(PersonnelChange, "typeName", "mono.contractintel.v1.PersonnelChange");
_define_property(PersonnelChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "position",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "previous_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "new_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "approval_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ModificationAuthority
 */ export class ModificationAuthority extends Message {
    static fromBinary(bytes, options) {
        return new ModificationAuthority().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModificationAuthority().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModificationAuthority().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModificationAuthority, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string type = 1;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModificationAuthority, "runtime", proto3);
_define_property(ModificationAuthority, "typeName", "mono.contractintel.v1.ModificationAuthority");
_define_property(ModificationAuthority, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Full modification entity.
 *
 * @generated from message mono.contractintel.v1.ContractModification
 */ export class ContractModification extends Message {
    static fromBinary(bytes, options) {
        return new ContractModification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractModification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractModification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractModification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string organization_id = 4;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: string modification_number = 10;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: string document_id = 11;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: mono.contractintel.v1.ModificationType modification_type = 12;
   */ _define_property(this, "modificationType", 0), /**
   * @generated from field: mono.contractintel.v1.ModificationStatus status = 13;
   */ _define_property(this, "status", 0), /**
   * @generated from field: google.protobuf.Timestamp status_updated_at = 14;
   */ _define_property(this, "statusUpdatedAt", void 0), /**
   * @generated from field: repeated mono.contractintel.v1.ChangeCategory change_categories = 20;
   */ _define_property(this, "changeCategories", []), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 21;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp signed_date = 22;
   */ _define_property(this, "signedDate", void 0), /**
   * @generated from field: mono.contractintel.v1.ModificationAuthority authority = 23;
   */ _define_property(this, "authority", void 0), /**
   * @generated from field: repeated mono.contractintel.v1.FundingChange funding_changes = 30;
   */ _define_property(this, "fundingChanges", []), /**
   * @generated from field: repeated mono.contractintel.v1.ScopeChange scope_changes = 31;
   */ _define_property(this, "scopeChanges", []), /**
   * @generated from field: repeated mono.contractintel.v1.PeriodChange period_changes = 32;
   */ _define_property(this, "periodChanges", []), /**
   * @generated from field: repeated mono.contractintel.v1.PersonnelChange personnel_changes = 33;
   */ _define_property(this, "personnelChanges", []), /**
   * @generated from field: double total_funding_change = 40;
   */ _define_property(this, "totalFundingChange", 0), /**
   * @generated from field: double cumulative_contract_value = 41;
   */ _define_property(this, "cumulativeContractValue", 0), /**
   * @generated from field: double extraction_confidence = 42;
   */ _define_property(this, "extractionConfidence", 0), /**
   * @generated from field: google.protobuf.Timestamp processed_at = 50;
   */ _define_property(this, "processedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 51;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 52;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractModification, "runtime", proto3);
_define_property(ContractModification, "typeName", "mono.contractintel.v1.ContractModification");
_define_property(ContractModification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "modification_type",
            kind: "enum",
            T: proto3.getEnumType(ModificationType)
        },
        {
            no: 13,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ModificationStatus)
        },
        {
            no: 14,
            name: "status_updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "change_categories",
            kind: "enum",
            T: proto3.getEnumType(ChangeCategory),
            repeated: true
        },
        {
            no: 21,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "signed_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "authority",
            kind: "message",
            T: ModificationAuthority
        },
        {
            no: 30,
            name: "funding_changes",
            kind: "message",
            T: FundingChange,
            repeated: true
        },
        {
            no: 31,
            name: "scope_changes",
            kind: "message",
            T: ScopeChange,
            repeated: true
        },
        {
            no: 32,
            name: "period_changes",
            kind: "message",
            T: PeriodChange,
            repeated: true
        },
        {
            no: 33,
            name: "personnel_changes",
            kind: "message",
            T: PersonnelChange,
            repeated: true
        },
        {
            no: 40,
            name: "total_funding_change",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 41,
            name: "cumulative_contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 42,
            name: "extraction_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 50,
            name: "processed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 51,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 52,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.SOWAnalysis
 */ export class SOWAnalysis extends Message {
    static fromBinary(bytes, options) {
        return new SOWAnalysis().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SOWAnalysis().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SOWAnalysis().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SOWAnalysis, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string source_file_id = 3;
   */ _define_property(this, "sourceFileId", ""), /**
   * The WHY
   *
   * @generated from field: string background = 10;
   */ _define_property(this, "background", ""), /**
   * The WHAT
   *
   * @generated from field: string scope = 11;
   */ _define_property(this, "scope", ""), /**
   * The WHEN
   *
   * @generated from field: string timeline = 12;
   */ _define_property(this, "timeline", ""), /**
   * The WHO
   *
   * @generated from field: string stakeholders = 13;
   */ _define_property(this, "stakeholders", ""), /**
   * The HOW
   *
   * @generated from field: string kickoff_requirements = 14;
   */ _define_property(this, "kickoffRequirements", ""), /**
   * @generated from field: string raw_summary = 20;
   */ _define_property(this, "rawSummary", ""), /**
   * @generated from field: google.protobuf.Timestamp analyzed_at = 21;
   */ _define_property(this, "analyzedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SOWAnalysis, "runtime", proto3);
_define_property(SOWAnalysis, "typeName", "mono.contractintel.v1.SOWAnalysis");
_define_property(SOWAnalysis, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "background",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "timeline",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "stakeholders",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "kickoff_requirements",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "raw_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "analyzed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.AnalyzeContractRequest
 */ export class AnalyzeContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * baltigo doc ID
   *
   * @generated from field: string source_file_id = 3;
   */ _define_property(this, "sourceFileId", ""), /**
   * @generated from field: string chat_id = 4;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string filename = 5;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 6;
   */ _define_property(this, "mimeType", ""), /**
   * MinIO paths from reverie's baltigo processing (avoids re-extraction)
   *
   * classified doc type (e.g., "SECTION_B", "AMENDMENT")
   *
   * @generated from field: string document_type = 7;
   */ _define_property(this, "documentType", ""), /**
   * MinIO path to processed HTML
   *
   * @generated from field: string html_path = 8;
   */ _define_property(this, "htmlPath", ""), /**
   * MinIO path to processed markdown
   *
   * @generated from field: string markdown_path = 9;
   */ _define_property(this, "markdownPath", ""), /**
   * MinIO path to pre-parsed blocks.json
   *
   * @generated from field: string blocks_path = 10;
   */ _define_property(this, "blocksPath", ""), /**
   * tenant ID for direct MinIO access
   *
   * @generated from field: string tenant_id = 11;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeContractRequest, "runtime", proto3);
_define_property(AnalyzeContractRequest, "typeName", "mono.contractintel.v1.AnalyzeContractRequest");
_define_property(AnalyzeContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "markdown_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.AnalyzeContractResponse
 */ export class AnalyzeContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractAnalysis contract = 1;
   */ _define_property(this, "contract", void 0), /**
   * @generated from field: bytes clins_csv = 2;
   */ _define_property(this, "clinsCsv", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeContractResponse, "runtime", proto3);
_define_property(AnalyzeContractResponse, "typeName", "mono.contractintel.v1.AnalyzeContractResponse");
_define_property(AnalyzeContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract",
            kind: "message",
            T: ContractAnalysis
        },
        {
            no: 2,
            name: "clins_csv",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.AnalyzeSOWRequest
 */ export class AnalyzeSOWRequest extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeSOWRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeSOWRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeSOWRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeSOWRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string source_file_id = 3;
   */ _define_property(this, "sourceFileId", ""), /**
   * @generated from field: string chat_id = 4;
   */ _define_property(this, "chatId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeSOWRequest, "runtime", proto3);
_define_property(AnalyzeSOWRequest, "typeName", "mono.contractintel.v1.AnalyzeSOWRequest");
_define_property(AnalyzeSOWRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.AnalyzeSOWResponse
 */ export class AnalyzeSOWResponse extends Message {
    static fromBinary(bytes, options) {
        return new AnalyzeSOWResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyzeSOWResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyzeSOWResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyzeSOWResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.SOWAnalysis analysis = 1;
   */ _define_property(this, "analysis", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnalyzeSOWResponse, "runtime", proto3);
_define_property(AnalyzeSOWResponse, "typeName", "mono.contractintel.v1.AnalyzeSOWResponse");
_define_property(AnalyzeSOWResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "analysis",
            kind: "message",
            T: SOWAnalysis
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetContractStatusRequest
 */ export class GetContractStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContractStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_number = 2;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractStatusRequest, "runtime", proto3);
_define_property(GetContractStatusRequest, "typeName", "mono.contractintel.v1.GetContractStatusRequest");
_define_property(GetContractStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetContractStatusResponse
 */ export class GetContractStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContractStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool exists = 1;
   */ _define_property(this, "exists", false), /**
   * @generated from field: mono.contractintel.v1.ContractAnalysisStatus status = 2;
   */ _define_property(this, "status", 0), /**
   * Legacy status field. Reports unique CLIN numbers.
   *
   * @generated from field: int32 clin_count = 3;
   */ _define_property(this, "clinCount", 0), /**
   * @generated from field: int32 deliverable_count = 4;
   */ _define_property(this, "deliverableCount", 0), /**
   * @generated from field: google.protobuf.Timestamp extraction_date = 5;
   */ _define_property(this, "extractionDate", void 0), /**
   * @generated from field: mono.contractintel.v1.ConfidenceScores confidence = 6;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: int32 unique_clin_numbers = 7;
   */ _define_property(this, "uniqueClinNumbers", 0), /**
   * @generated from field: int32 unique_clin_period_entries = 8;
   */ _define_property(this, "uniqueClinPeriodEntries", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractStatusResponse, "runtime", proto3);
_define_property(GetContractStatusResponse, "typeName", "mono.contractintel.v1.GetContractStatusResponse");
_define_property(GetContractStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exists",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ContractAnalysisStatus)
        },
        {
            no: 3,
            name: "clin_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "deliverable_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "extraction_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "confidence",
            kind: "message",
            T: ConfidenceScores
        },
        {
            no: 7,
            name: "unique_clin_numbers",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "unique_clin_period_entries",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetContractRequest
 */ export class GetContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * Lookup by either id or contract_number.
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractRequest, "runtime", proto3);
_define_property(GetContractRequest, "typeName", "mono.contractintel.v1.GetContractRequest");
_define_property(GetContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetContractResponse
 */ export class GetContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractAnalysis contract = 1;
   */ _define_property(this, "contract", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractResponse, "runtime", proto3);
_define_property(GetContractResponse, "typeName", "mono.contractintel.v1.GetContractResponse");
_define_property(GetContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract",
            kind: "message",
            T: ContractAnalysis
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ListContractsRequest
 */ export class ListContractsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContractsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 3;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractsRequest, "runtime", proto3);
_define_property(ListContractsRequest, "typeName", "mono.contractintel.v1.ListContractsRequest");
_define_property(ListContractsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ListContractsResponse
 */ export class ListContractsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContractsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.contractintel.v1.ContractAnalysis contracts = 1;
   */ _define_property(this, "contracts", []), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractsResponse, "runtime", proto3);
_define_property(ListContractsResponse, "typeName", "mono.contractintel.v1.ListContractsResponse");
_define_property(ListContractsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contracts",
            kind: "message",
            T: ContractAnalysis,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.DeleteContractRequest
 */ export class DeleteContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractRequest, "runtime", proto3);
_define_property(DeleteContractRequest, "typeName", "mono.contractintel.v1.DeleteContractRequest");
_define_property(DeleteContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.DeleteContractResponse
 */ export class DeleteContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractResponse, "runtime", proto3);
_define_property(DeleteContractResponse, "typeName", "mono.contractintel.v1.DeleteContractResponse");
_define_property(DeleteContractResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.contractintel.v1.QueryCLINsRequest
 */ export class QueryCLINsRequest extends Message {
    static fromBinary(bytes, options) {
        return new QueryCLINsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryCLINsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryCLINsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryCLINsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * Query all CLINs across contracts for a project
   *
   * @generated from field: string project_id = 12;
   */ _define_property(this, "projectId", ""), /**
   * Filters
   *
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: mono.contractintel.v1.CLINOptionType option_type = 5;
   */ _define_property(this, "optionType", 0), /**
   * @generated from field: mono.contractintel.v1.CLINContractType contract_type = 6;
   */ _define_property(this, "contractType", 0), /**
   * @generated from field: mono.contractintel.v1.FundingStatus funding_status = 7;
   */ _define_property(this, "fundingStatus", 0), /**
   * free-text search across description, PWS sections
   *
   * @generated from field: string search = 8;
   */ _define_property(this, "search", ""), /**
   * Sort
   *
   * @generated from field: string sort_by = 9;
   */ _define_property(this, "sortBy", ""), /**
   * @generated from field: string sort_direction = 10;
   */ _define_property(this, "sortDirection", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 11;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryCLINsRequest, "runtime", proto3);
_define_property(QueryCLINsRequest, "typeName", "mono.contractintel.v1.QueryCLINsRequest");
_define_property(QueryCLINsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "option_type",
            kind: "enum",
            T: proto3.getEnumType(CLINOptionType)
        },
        {
            no: 6,
            name: "contract_type",
            kind: "enum",
            T: proto3.getEnumType(CLINContractType)
        },
        {
            no: 7,
            name: "funding_status",
            kind: "enum",
            T: proto3.getEnumType(FundingStatus)
        },
        {
            no: 8,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sort_direction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.QueryCLINsResponse
 */ export class QueryCLINsResponse extends Message {
    static fromBinary(bytes, options) {
        return new QueryCLINsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryCLINsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryCLINsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryCLINsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.contractintel.v1.ContractCLIN clins = 1;
   */ _define_property(this, "clins", []), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryCLINsResponse, "runtime", proto3);
_define_property(QueryCLINsResponse, "typeName", "mono.contractintel.v1.QueryCLINsResponse");
_define_property(QueryCLINsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clins",
            kind: "message",
            T: ContractCLIN,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetCLINRequest
 */ export class GetCLINRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCLINRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCLINRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCLINRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCLINRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCLINRequest, "runtime", proto3);
_define_property(GetCLINRequest, "typeName", "mono.contractintel.v1.GetCLINRequest");
_define_property(GetCLINRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetCLINResponse
 */ export class GetCLINResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCLINResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCLINResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCLINResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCLINResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractCLIN clin = 1;
   */ _define_property(this, "clin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCLINResponse, "runtime", proto3);
_define_property(GetCLINResponse, "typeName", "mono.contractintel.v1.GetCLINResponse");
_define_property(GetCLINResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.UpdateCLINFundingRequest
 */ export class UpdateCLINFundingRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCLINFundingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCLINFundingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCLINFundingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCLINFundingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string clin_id = 2;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: mono.contractintel.v1.FundingStatus funding_status = 3;
   */ _define_property(this, "fundingStatus", 0), /**
   * @generated from field: double funded_amount = 4;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double unfunded_amount = 5;
   */ _define_property(this, "unfundedAmount", 0), /**
   * @generated from field: string change_reason = 6;
   */ _define_property(this, "changeReason", ""), /**
   * @generated from field: string modification_id = 7;
   */ _define_property(this, "modificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCLINFundingRequest, "runtime", proto3);
_define_property(UpdateCLINFundingRequest, "typeName", "mono.contractintel.v1.UpdateCLINFundingRequest");
_define_property(UpdateCLINFundingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "funding_status",
            kind: "enum",
            T: proto3.getEnumType(FundingStatus)
        },
        {
            no: 4,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "change_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.UpdateCLINFundingResponse
 */ export class UpdateCLINFundingResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCLINFundingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCLINFundingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCLINFundingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCLINFundingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractCLIN clin = 1;
   */ _define_property(this, "clin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCLINFundingResponse, "runtime", proto3);
_define_property(UpdateCLINFundingResponse, "typeName", "mono.contractintel.v1.UpdateCLINFundingResponse");
_define_property(UpdateCLINFundingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ExportCLINsCSVRequest
 */ export class ExportCLINsCSVRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExportCLINsCSVRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportCLINsCSVRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportCLINsCSVRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportCLINsCSVRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportCLINsCSVRequest, "runtime", proto3);
_define_property(ExportCLINsCSVRequest, "typeName", "mono.contractintel.v1.ExportCLINsCSVRequest");
_define_property(ExportCLINsCSVRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ExportCLINsCSVResponse
 */ export class ExportCLINsCSVResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExportCLINsCSVResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportCLINsCSVResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportCLINsCSVResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportCLINsCSVResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes csv_data = 1;
   */ _define_property(this, "csvData", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportCLINsCSVResponse, "runtime", proto3);
_define_property(ExportCLINsCSVResponse, "typeName", "mono.contractintel.v1.ExportCLINsCSVResponse");
_define_property(ExportCLINsCSVResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "csv_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.QueryDeliverablesRequest
 */ export class QueryDeliverablesRequest extends Message {
    static fromBinary(bytes, options) {
        return new QueryDeliverablesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryDeliverablesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryDeliverablesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryDeliverablesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string clin_id = 3;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string search = 5;
   */ _define_property(this, "search", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 6;
   */ _define_property(this, "pagination", void 0), /**
   * @generated from field: string contract_number = 7;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string project_id = 8;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryDeliverablesRequest, "runtime", proto3);
_define_property(QueryDeliverablesRequest, "typeName", "mono.contractintel.v1.QueryDeliverablesRequest");
_define_property(QueryDeliverablesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 7,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.QueryDeliverablesResponse
 */ export class QueryDeliverablesResponse extends Message {
    static fromBinary(bytes, options) {
        return new QueryDeliverablesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryDeliverablesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryDeliverablesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryDeliverablesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.contractintel.v1.ContractDeliverable deliverables = 1;
   */ _define_property(this, "deliverables", []), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryDeliverablesResponse, "runtime", proto3);
_define_property(QueryDeliverablesResponse, "typeName", "mono.contractintel.v1.QueryDeliverablesResponse");
_define_property(QueryDeliverablesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverables",
            kind: "message",
            T: ContractDeliverable,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.UpdateDeliverableStatusRequest
 */ export class UpdateDeliverableStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string deliverable_id = 2;
   */ _define_property(this, "deliverableId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableStatusRequest, "runtime", proto3);
_define_property(UpdateDeliverableStatusRequest, "typeName", "mono.contractintel.v1.UpdateDeliverableStatusRequest");
_define_property(UpdateDeliverableStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.UpdateDeliverableStatusResponse
 */ export class UpdateDeliverableStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractDeliverable deliverable = 1;
   */ _define_property(this, "deliverable", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableStatusResponse, "runtime", proto3);
_define_property(UpdateDeliverableStatusResponse, "typeName", "mono.contractintel.v1.UpdateDeliverableStatusResponse");
_define_property(UpdateDeliverableStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable",
            kind: "message",
            T: ContractDeliverable
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.SubmitDeliverableRequest
 */ export class SubmitDeliverableRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitDeliverableRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitDeliverableRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitDeliverableRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitDeliverableRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string deliverable_id = 2;
   */ _define_property(this, "deliverableId", ""), /**
   * @generated from field: bytes file_data = 3;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 4;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 5;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitDeliverableRequest, "runtime", proto3);
_define_property(SubmitDeliverableRequest, "typeName", "mono.contractintel.v1.SubmitDeliverableRequest");
_define_property(SubmitDeliverableRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 4,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ExtractInvoiceMetadataRequest
 */ export class ExtractInvoiceMetadataRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractInvoiceMetadataRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractInvoiceMetadataRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractInvoiceMetadataRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractInvoiceMetadataRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: bytes file_data = 2;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 3;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 4;
   */ _define_property(this, "contentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractInvoiceMetadataRequest, "runtime", proto3);
_define_property(ExtractInvoiceMetadataRequest, "typeName", "mono.contractintel.v1.ExtractInvoiceMetadataRequest");
_define_property(ExtractInvoiceMetadataRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 3,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ExtractInvoiceMetadataResponse
 */ export class ExtractInvoiceMetadataResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractInvoiceMetadataResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractInvoiceMetadataResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractInvoiceMetadataResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractInvoiceMetadataResponse, a, b);
    }
    constructor(data){
        super(), /**
   * YYYY-MM-DD, or empty if none could be read
   *
   * @generated from field: string invoice_date = 1;
   */ _define_property(this, "invoiceDate", ""), /**
   * 0..1, zero when no date was found
   *
   * @generated from field: double confidence = 2;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractInvoiceMetadataResponse, "runtime", proto3);
_define_property(ExtractInvoiceMetadataResponse, "typeName", "mono.contractintel.v1.ExtractInvoiceMetadataResponse");
_define_property(ExtractInvoiceMetadataResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "invoice_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.SubmitDeliverableResponse
 */ export class SubmitDeliverableResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitDeliverableResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitDeliverableResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitDeliverableResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitDeliverableResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.DeliverableSubmission submission = 1;
   */ _define_property(this, "submission", void 0), /**
   * @generated from field: mono.contractintel.v1.ContractDeliverable deliverable = 2;
   */ _define_property(this, "deliverable", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitDeliverableResponse, "runtime", proto3);
_define_property(SubmitDeliverableResponse, "typeName", "mono.contractintel.v1.SubmitDeliverableResponse");
_define_property(SubmitDeliverableResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: DeliverableSubmission
        },
        {
            no: 2,
            name: "deliverable",
            kind: "message",
            T: ContractDeliverable
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ListDeliverableSubmissionsRequest
 */ export class ListDeliverableSubmissionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableSubmissionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableSubmissionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableSubmissionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableSubmissionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string deliverable_id = 2;
   */ _define_property(this, "deliverableId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableSubmissionsRequest, "runtime", proto3);
_define_property(ListDeliverableSubmissionsRequest, "typeName", "mono.contractintel.v1.ListDeliverableSubmissionsRequest");
_define_property(ListDeliverableSubmissionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ListDeliverableSubmissionsResponse
 */ export class ListDeliverableSubmissionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableSubmissionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableSubmissionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableSubmissionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableSubmissionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.contractintel.v1.DeliverableSubmission submissions = 1;
   */ _define_property(this, "submissions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableSubmissionsResponse, "runtime", proto3);
_define_property(ListDeliverableSubmissionsResponse, "typeName", "mono.contractintel.v1.ListDeliverableSubmissionsResponse");
_define_property(ListDeliverableSubmissionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: DeliverableSubmission,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.DownloadSubmissionRequest
 */ export class DownloadSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new DownloadSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string submission_id = 2;
   */ _define_property(this, "submissionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadSubmissionRequest, "runtime", proto3);
_define_property(DownloadSubmissionRequest, "typeName", "mono.contractintel.v1.DownloadSubmissionRequest");
_define_property(DownloadSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.DownloadSubmissionResponse
 */ export class DownloadSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new DownloadSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadSubmissionResponse, "runtime", proto3);
_define_property(DownloadSubmissionResponse, "typeName", "mono.contractintel.v1.DownloadSubmissionResponse");
_define_property(DownloadSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ParseModificationRequest
 */ export class ParseModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new ParseModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParseModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParseModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParseModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string document_file_id = 3;
   */ _define_property(this, "documentFileId", ""), /**
   * @generated from field: string filename = 4;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 5;
   */ _define_property(this, "mimeType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParseModificationRequest, "runtime", proto3);
_define_property(ParseModificationRequest, "typeName", "mono.contractintel.v1.ParseModificationRequest");
_define_property(ParseModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ParseModificationResponse
 */ export class ParseModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new ParseModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParseModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParseModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParseModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractModification modification = 1;
   */ _define_property(this, "modification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParseModificationResponse, "runtime", proto3);
_define_property(ParseModificationResponse, "typeName", "mono.contractintel.v1.ParseModificationResponse");
_define_property(ParseModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification",
            kind: "message",
            T: ContractModification
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ListModificationsRequest
 */ export class ListModificationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListModificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListModificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListModificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListModificationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 4;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListModificationsRequest, "runtime", proto3);
_define_property(ListModificationsRequest, "typeName", "mono.contractintel.v1.ListModificationsRequest");
_define_property(ListModificationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ListModificationsResponse
 */ export class ListModificationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListModificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListModificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListModificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListModificationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.contractintel.v1.ContractModification modifications = 1;
   */ _define_property(this, "modifications", []), /**
   * @generated from field: mono.common.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListModificationsResponse, "runtime", proto3);
_define_property(ListModificationsResponse, "typeName", "mono.contractintel.v1.ListModificationsResponse");
_define_property(ListModificationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modifications",
            kind: "message",
            T: ContractModification,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetModificationRequest
 */ export class GetModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetModificationRequest, "runtime", proto3);
_define_property(GetModificationRequest, "typeName", "mono.contractintel.v1.GetModificationRequest");
_define_property(GetModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetModificationResponse
 */ export class GetModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractModification modification = 1;
   */ _define_property(this, "modification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetModificationResponse, "runtime", proto3);
_define_property(GetModificationResponse, "typeName", "mono.contractintel.v1.GetModificationResponse");
_define_property(GetModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification",
            kind: "message",
            T: ContractModification
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ApplyModificationRequest
 */ export class ApplyModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string modification_id = 2;
   */ _define_property(this, "modificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyModificationRequest, "runtime", proto3);
_define_property(ApplyModificationRequest, "typeName", "mono.contractintel.v1.ApplyModificationRequest");
_define_property(ApplyModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ApplyModificationResponse
 */ export class ApplyModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractModification modification = 1;
   */ _define_property(this, "modification", void 0), /**
   * CLINs that were updated as a result of applying the modification.
   *
   * @generated from field: repeated mono.contractintel.v1.ContractCLIN updated_clins = 2;
   */ _define_property(this, "updatedClins", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyModificationResponse, "runtime", proto3);
_define_property(ApplyModificationResponse, "typeName", "mono.contractintel.v1.ApplyModificationResponse");
_define_property(ApplyModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification",
            kind: "message",
            T: ContractModification
        },
        {
            no: 2,
            name: "updated_clins",
            kind: "message",
            T: ContractCLIN,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetModificationDiffRequest
 */ export class GetModificationDiffRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetModificationDiffRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetModificationDiffRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetModificationDiffRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetModificationDiffRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string modification_id = 2;
   */ _define_property(this, "modificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetModificationDiffRequest, "runtime", proto3);
_define_property(GetModificationDiffRequest, "typeName", "mono.contractintel.v1.GetModificationDiffRequest");
_define_property(GetModificationDiffRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GetModificationDiffResponse
 */ export class GetModificationDiffResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetModificationDiffResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetModificationDiffResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetModificationDiffResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetModificationDiffResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractModification modification = 1;
   */ _define_property(this, "modification", void 0), /**
   * @generated from field: repeated mono.contractintel.v1.FundingChange funding_changes = 2;
   */ _define_property(this, "fundingChanges", []), /**
   * @generated from field: repeated mono.contractintel.v1.ScopeChange scope_changes = 3;
   */ _define_property(this, "scopeChanges", []), /**
   * @generated from field: repeated mono.contractintel.v1.PeriodChange period_changes = 4;
   */ _define_property(this, "periodChanges", []), /**
   * @generated from field: repeated mono.contractintel.v1.PersonnelChange personnel_changes = 5;
   */ _define_property(this, "personnelChanges", []), /**
   * @generated from field: double net_funding_impact = 6;
   */ _define_property(this, "netFundingImpact", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetModificationDiffResponse, "runtime", proto3);
_define_property(GetModificationDiffResponse, "typeName", "mono.contractintel.v1.GetModificationDiffResponse");
_define_property(GetModificationDiffResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification",
            kind: "message",
            T: ContractModification
        },
        {
            no: 2,
            name: "funding_changes",
            kind: "message",
            T: FundingChange,
            repeated: true
        },
        {
            no: 3,
            name: "scope_changes",
            kind: "message",
            T: ScopeChange,
            repeated: true
        },
        {
            no: 4,
            name: "period_changes",
            kind: "message",
            T: PeriodChange,
            repeated: true
        },
        {
            no: 5,
            name: "personnel_changes",
            kind: "message",
            T: PersonnelChange,
            repeated: true
        },
        {
            no: 6,
            name: "net_funding_impact",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GeneratePMPRequest
 */ export class GeneratePMPRequest extends Message {
    static fromBinary(bytes, options) {
        return new GeneratePMPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GeneratePMPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GeneratePMPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GeneratePMPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GeneratePMPRequest, "runtime", proto3);
_define_property(GeneratePMPRequest, "typeName", "mono.contractintel.v1.GeneratePMPRequest");
_define_property(GeneratePMPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GeneratePMPResponse
 */ export class GeneratePMPResponse extends Message {
    static fromBinary(bytes, options) {
        return new GeneratePMPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GeneratePMPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GeneratePMPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GeneratePMPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * Markdown content
   *
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string filename = 3;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GeneratePMPResponse, "runtime", proto3);
_define_property(GeneratePMPResponse, "typeName", "mono.contractintel.v1.GeneratePMPResponse");
_define_property(GeneratePMPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GenerateBillingScheduleRequest
 */ export class GenerateBillingScheduleRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateBillingScheduleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateBillingScheduleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateBillingScheduleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateBillingScheduleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string contract_id = 2;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateBillingScheduleRequest, "runtime", proto3);
_define_property(GenerateBillingScheduleRequest, "typeName", "mono.contractintel.v1.GenerateBillingScheduleRequest");
_define_property(GenerateBillingScheduleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GenerateBillingScheduleResponse
 */ export class GenerateBillingScheduleResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateBillingScheduleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateBillingScheduleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateBillingScheduleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateBillingScheduleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string filename = 3;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateBillingScheduleResponse, "runtime", proto3);
_define_property(GenerateBillingScheduleResponse, "typeName", "mono.contractintel.v1.GenerateBillingScheduleResponse");
_define_property(GenerateBillingScheduleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PingRequest
 */ export class PingRequest extends Message {
    static fromBinary(bytes, options) {
        return new PingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingRequest, "runtime", proto3);
_define_property(PingRequest, "typeName", "mono.contractintel.v1.PingRequest");
_define_property(PingRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.contractintel.v1.PingResponse
 */ export class PingResponse extends Message {
    static fromBinary(bytes, options) {
        return new PingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingResponse, "runtime", proto3);
_define_property(PingResponse, "typeName", "mono.contractintel.v1.PingResponse");
_define_property(PingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * AwardedContractData — structured snapshot of a fully-executed award
 * package. Phase 0b's `awardcompare` engine (services/zou/pkg/awardcompare/)
 * diffs this against the frozen BidBaseline + 8 ReadinessPackages and emits
 * DiscrepancyRecord drafts.
 *
 * Intentionally distinct from `ContractAnalysis` above — `ContractAnalysis`
 * is the iceburg-persisted contract registry shape, whereas
 * `AwardedContractData` is the transient extraction emitted by baltigo's
 * `ExtractAwardedContract` and consumed by zou's `BeginAwardComparison`.
 * Keeping them apart lets the two pipelines evolve independently.
 *
 * Field selection mirrors what the 9 SDS §4 comparison areas read; new
 * areas append rather than mutate existing fields. Empty/zero values are
 * treated as "missing" by the engine — `Informational` discrepancy with a
 * `LowConfidence` hint flag — rather than as zero-valued reality.
 *
 * @generated from message mono.contractintel.v1.AwardedContractData
 */ export class AwardedContractData extends Message {
    static fromBinary(bytes, options) {
        return new AwardedContractData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardedContractData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardedContractData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardedContractData, a, b);
    }
    constructor(data){
        super(), /**
   * Identity / vehicle / agency
   *
   * @generated from field: string contract_number = 1;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string contract_title = 2;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: mono.contractintel.v1.ContractType contract_type = 3;
   */ _define_property(this, "contractType", 0), /**
   * @generated from field: mono.contractintel.v1.AgencyInfo agency = 4;
   */ _define_property(this, "agency", void 0), /**
   * @generated from field: mono.contractintel.v1.ContractVehicle contracting_vehicle = 5;
   */ _define_property(this, "contractingVehicle", void 0), /**
   * @generated from field: string task_order_number = 6;
   */ _define_property(this, "taskOrderNumber", ""), /**
   * Dates
   *
   * @generated from field: google.protobuf.Timestamp award_date = 10;
   */ _define_property(this, "awardDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 11;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: mono.contractintel.v1.PeriodOfPerformance period_of_performance = 12;
   */ _define_property(this, "periodOfPerformance", void 0), /**
   * Funding
   *
   * @generated from field: mono.contractintel.v1.ContractValue total_value = 20;
   */ _define_property(this, "totalValue", void 0), /**
   * @generated from field: double funded_amount = 21;
   */ _define_property(this, "fundedAmount", 0), /**
   * ISO-4217; defaults to USD
   *
   * @generated from field: string currency = 22;
   */ _define_property(this, "currency", ""), /**
   * Dollars obligated at award — distinct from funded_amount and from
   * total_value's ceiling. Carried down from AwardedContractDataV2's
   * obligated_amount (see its comment for the SF1449 provenance).
   *
   * @generated from field: double obligated_amount = 23;
   */ _define_property(this, "obligatedAmount", 0), /**
   * Structural rows (each is full ContractCLIN / ContractDeliverable etc.)
   *
   * @generated from field: repeated mono.contractintel.v1.ContractCLIN clins = 30;
   */ _define_property(this, "clins", []), /**
   * @generated from field: repeated mono.contractintel.v1.ContractDeliverable deliverables = 31;
   */ _define_property(this, "deliverables", []), /**
   * @generated from field: repeated mono.contractintel.v1.PlaceOfPerformance places_of_performance = 32;
   */ _define_property(this, "placesOfPerformance", []), /**
   * @generated from field: repeated mono.contractintel.v1.GovernmentContact government_contacts = 33;
   */ _define_property(this, "governmentContacts", []), /**
   * Optional commitments lifted from the award package — kept loose so the
   * engine can tolerate partial extraction.
   *
   * @generated from field: repeated string key_personnel_names = 40;
   */ _define_property(this, "keyPersonnelNames", []), /**
   * @generated from field: repeated string compliance_obligations = 41;
   */ _define_property(this, "complianceObligations", []), /**
   * Provenance — every field above is sourced from these PDF artifacts.
   * Engine ships this with the DiscrepancyDraft so reviewers can jump to
   * the source.
   *
   * @generated from field: repeated string source_artifact_ids = 50;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * Extraction metadata
   *
   * @generated from field: google.protobuf.Timestamp extracted_at = 60;
   */ _define_property(this, "extractedAt", void 0), /**
   * @generated from field: string extraction_version = 61;
   */ _define_property(this, "extractionVersion", ""), /**
   * @generated from field: mono.contractintel.v1.ConfidenceScores confidence = 62;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: repeated string extraction_notes = 63;
   */ _define_property(this, "extractionNotes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardedContractData, "runtime", proto3);
_define_property(AwardedContractData, "typeName", "mono.contractintel.v1.AwardedContractData");
_define_property(AwardedContractData, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_type",
            kind: "enum",
            T: proto3.getEnumType(ContractType)
        },
        {
            no: 4,
            name: "agency",
            kind: "message",
            T: AgencyInfo
        },
        {
            no: 5,
            name: "contracting_vehicle",
            kind: "message",
            T: ContractVehicle
        },
        {
            no: 6,
            name: "task_order_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "award_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        },
        {
            no: 20,
            name: "total_value",
            kind: "message",
            T: ContractValue
        },
        {
            no: 21,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 22,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "obligated_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 30,
            name: "clins",
            kind: "message",
            T: ContractCLIN,
            repeated: true
        },
        {
            no: 31,
            name: "deliverables",
            kind: "message",
            T: ContractDeliverable,
            repeated: true
        },
        {
            no: 32,
            name: "places_of_performance",
            kind: "message",
            T: PlaceOfPerformance,
            repeated: true
        },
        {
            no: 33,
            name: "government_contacts",
            kind: "message",
            T: GovernmentContact,
            repeated: true
        },
        {
            no: 40,
            name: "key_personnel_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 41,
            name: "compliance_obligations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 50,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 60,
            name: "extracted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 61,
            name: "extraction_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 62,
            name: "confidence",
            kind: "message",
            T: ConfidenceScores
        },
        {
            no: 63,
            name: "extraction_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.AwardedContractDataV2
 */ export class AwardedContractDataV2 extends Message {
    static fromBinary(bytes, options) {
        return new AwardedContractDataV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardedContractDataV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardedContractDataV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardedContractDataV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractIdentityV2 identity = 1;
   */ _define_property(this, "identity", void 0), /**
   * two-office semantics (corrective §4.2)
   *
   * @generated from field: mono.contractintel.v1.GovernmentOrgsV2 government_orgs = 2;
   */ _define_property(this, "governmentOrgs", void 0), /**
   * reused; a vehicle is never a pricing type (§4.1)
   *
   * @generated from field: mono.contractintel.v1.ContractVehicle vehicle = 3;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: mono.contractintel.v1.ContractType contract_type = 4;
   */ _define_property(this, "contractType", 0), /**
   * @generated from field: mono.contractintel.v1.ContractValue total_value = 5;
   */ _define_property(this, "totalValue", void 0), /**
   * @generated from field: double funded_amount = 6;
   */ _define_property(this, "fundedAmount", 0), /**
   * ISO-4217; defaults to USD
   *
   * @generated from field: string currency = 7;
   */ _define_property(this, "currency", ""), /**
   * Dollars explicitly obligated at award. A cover's Total Award Amount alone
   * is insufficient; the source must label obligation or explicitly link it.
   *
   * @generated from field: double obligated_amount = 19;
   */ _define_property(this, "obligatedAmount", 0), /**
   * @generated from field: repeated mono.contractintel.v1.ContractPartyV2 parties = 8;
   */ _define_property(this, "parties", []), /**
   * @generated from field: repeated mono.contractintel.v1.ContractDateV2 dates = 9;
   */ _define_property(this, "dates", []), /**
   * @generated from field: repeated mono.contractintel.v1.ContractPeriodV2 periods = 10;
   */ _define_property(this, "periods", []), /**
   * @generated from field: repeated mono.contractintel.v1.AwardedClinV2 clins = 11;
   */ _define_property(this, "clins", []), /**
   * @generated from field: repeated mono.contractintel.v1.PwsObligationV2 pws_obligations = 12;
   */ _define_property(this, "pwsObligations", []), /**
   * @generated from field: repeated mono.contractintel.v1.DeliverableDefinitionV2 deliverable_definitions = 13;
   */ _define_property(this, "deliverableDefinitions", []), /**
   * @generated from field: repeated mono.contractintel.v1.ContractContactV2 contacts = 14;
   */ _define_property(this, "contacts", []), /**
   * @generated from field: repeated mono.contractintel.v1.StaffingRequirementV2 staffing_requirements = 15;
   */ _define_property(this, "staffingRequirements", []), /**
   * @generated from field: repeated mono.contractintel.v1.SubcontractRequirementV2 subcontract_requirements = 16;
   */ _define_property(this, "subcontractRequirements", []), /**
   * @generated from field: repeated mono.contractintel.v1.ComplianceRequirementV2 compliance_requirements = 17;
   */ _define_property(this, "complianceRequirements", []), /**
   * @generated from field: repeated mono.contractintel.v1.FinancialTermV2 financial_terms = 18;
   */ _define_property(this, "financialTerms", []), /**
   * One SourceMetadata per extracted value (→ a delivery.source_references row).
   *
   * @generated from field: repeated mono.contractintel.v1.SourceMetadata source_references = 20;
   */ _define_property(this, "sourceReferences", []), /**
   * @generated from field: mono.contractintel.v1.ExtractionSummaryV2 extraction_summary = 21;
   */ _define_property(this, "extractionSummary", void 0), /**
   * Facts code could not settle (D93); staged into the AwardImport set.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 22;
   */ _define_property(this, "reviewItems", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardedContractDataV2, "runtime", proto3);
_define_property(AwardedContractDataV2, "typeName", "mono.contractintel.v1.AwardedContractDataV2");
_define_property(AwardedContractDataV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "identity",
            kind: "message",
            T: ContractIdentityV2
        },
        {
            no: 2,
            name: "government_orgs",
            kind: "message",
            T: GovernmentOrgsV2
        },
        {
            no: 3,
            name: "vehicle",
            kind: "message",
            T: ContractVehicle
        },
        {
            no: 4,
            name: "contract_type",
            kind: "enum",
            T: proto3.getEnumType(ContractType)
        },
        {
            no: 5,
            name: "total_value",
            kind: "message",
            T: ContractValue
        },
        {
            no: 6,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "obligated_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "parties",
            kind: "message",
            T: ContractPartyV2,
            repeated: true
        },
        {
            no: 9,
            name: "dates",
            kind: "message",
            T: ContractDateV2,
            repeated: true
        },
        {
            no: 10,
            name: "periods",
            kind: "message",
            T: ContractPeriodV2,
            repeated: true
        },
        {
            no: 11,
            name: "clins",
            kind: "message",
            T: AwardedClinV2,
            repeated: true
        },
        {
            no: 12,
            name: "pws_obligations",
            kind: "message",
            T: PwsObligationV2,
            repeated: true
        },
        {
            no: 13,
            name: "deliverable_definitions",
            kind: "message",
            T: DeliverableDefinitionV2,
            repeated: true
        },
        {
            no: 14,
            name: "contacts",
            kind: "message",
            T: ContractContactV2,
            repeated: true
        },
        {
            no: 15,
            name: "staffing_requirements",
            kind: "message",
            T: StaffingRequirementV2,
            repeated: true
        },
        {
            no: 16,
            name: "subcontract_requirements",
            kind: "message",
            T: SubcontractRequirementV2,
            repeated: true
        },
        {
            no: 17,
            name: "compliance_requirements",
            kind: "message",
            T: ComplianceRequirementV2,
            repeated: true
        },
        {
            no: 18,
            name: "financial_terms",
            kind: "message",
            T: FinancialTermV2,
            repeated: true
        },
        {
            no: 20,
            name: "source_references",
            kind: "message",
            T: SourceMetadata,
            repeated: true
        },
        {
            no: 21,
            name: "extraction_summary",
            kind: "message",
            T: ExtractionSummaryV2
        },
        {
            no: 22,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        }
    ]));
/**
 * SourceMetadata — per-value source metadata (corrective §6.7). Persisted as a
 * delivery.source_references row; field names align with models.SourceReference
 * so the persistence mapping is mechanical (source_location folds into
 * source_page/source_section/source_quote).
 *
 * @generated from message mono.contractintel.v1.SourceMetadata
 */ export class SourceMetadata extends Message {
    static fromBinary(bytes, options) {
        return new SourceMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * What this value attaches to — e.g. ("CLIN", "0004", "funded_amount").
   *
   * @generated from field: string target_object_type = 1;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 2;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 3;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: string source_artifact_id = 4;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: mono.contractintel.v1.SourceLocationV2 source_location = 5;
   */ _define_property(this, "sourceLocation", void 0), /**
   * verbatim text extracted from the document
   *
   * @generated from field: string raw_value = 6;
   */ _define_property(this, "rawValue", ""), /**
   * parsed/canonical form (the proposed value)
   *
   * @generated from field: string normalized_value = 7;
   */ _define_property(this, "normalizedValue", ""), /**
   * @generated from field: double confidence = 8;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: repeated string extraction_warnings = 9;
   */ _define_property(this, "extractionWarnings", []), /**
   * @generated from field: mono.contractintel.v1.SourceKindV2 source_kind = 10;
   */ _define_property(this, "sourceKind", 0), /**
   * @generated from field: mono.contractintel.v1.SourceReviewState review_state = 11;
   */ _define_property(this, "reviewState", 0), /**
   * @generated from field: bool current_version_flag = 12;
   */ _define_property(this, "currentVersionFlag", false), /**
   * @generated from field: string superseded_by_id = 13;
   */ _define_property(this, "supersededById", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceMetadata, "runtime", proto3);
_define_property(SourceMetadata, "typeName", "mono.contractintel.v1.SourceMetadata");
_define_property(SourceMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_location",
            kind: "message",
            T: SourceLocationV2
        },
        {
            no: 6,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "normalized_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "extraction_warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "source_kind",
            kind: "enum",
            T: proto3.getEnumType(SourceKindV2)
        },
        {
            no: 11,
            name: "review_state",
            kind: "enum",
            T: proto3.getEnumType(SourceReviewState)
        },
        {
            no: 12,
            name: "current_version_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.SourceLocationV2
 */ export class SourceLocationV2 extends Message {
    static fromBinary(bytes, options) {
        return new SourceLocationV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceLocationV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceLocationV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceLocationV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string section = 2;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string paragraph = 3;
   */ _define_property(this, "paragraph", ""), /**
   * @generated from field: int32 table_row = 4;
   */ _define_property(this, "tableRow", 0), /**
   * @generated from field: int32 table_cell = 5;
   */ _define_property(this, "tableCell", 0), /**
   * char span / bbox, serialized
   *
   * @generated from field: string span = 6;
   */ _define_property(this, "span", ""), /**
   * the exact source text the value was read from
   *
   * @generated from field: string quote = 7;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceLocationV2, "runtime", proto3);
_define_property(SourceLocationV2, "typeName", "mono.contractintel.v1.SourceLocationV2");
_define_property(SourceLocationV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "paragraph",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "table_row",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "table_cell",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractIdentityV2
 */ export class ContractIdentityV2 extends Message {
    static fromBinary(bytes, options) {
        return new ContractIdentityV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractIdentityV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractIdentityV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractIdentityV2, a, b);
    }
    constructor(data){
        super(), /**
   * PIID
   *
   * @generated from field: string contract_number = 1;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string task_order_number = 2;
   */ _define_property(this, "taskOrderNumber", ""), /**
   * @generated from field: string call_number = 3;
   */ _define_property(this, "callNumber", ""), /**
   * @generated from field: string parent_award_id = 4;
   */ _define_property(this, "parentAwardId", ""), /**
   * @generated from field: string solicitation_number = 5;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string short_name = 7;
   */ _define_property(this, "shortName", ""), /**
   * 6-digit NAICS code (e.g. "541512")
   *
   * @generated from field: string naics = 8;
   */ _define_property(this, "naics", ""), /**
   * Explicitly checked acquisition category; empty when not established.
   *
   * @generated from field: string set_aside = 9;
   */ _define_property(this, "setAside", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractIdentityV2, "runtime", proto3);
_define_property(ContractIdentityV2, "typeName", "mono.contractintel.v1.ContractIdentityV2");
_define_property(ContractIdentityV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "task_order_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "call_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_award_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "short_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "naics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Two-office semantics (corrective §4.2): the office that awards/administers is
 * distinct from the customer the work is for; vehicles add an ordering office.
 *
 * @generated from message mono.contractintel.v1.GovernmentOrgsV2
 */ export class GovernmentOrgsV2 extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentOrgsV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentOrgsV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentOrgsV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentOrgsV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.GovernmentOrgRef contracting_office = 1;
   */ _define_property(this, "contractingOffice", void 0), /**
   * @generated from field: mono.contractintel.v1.GovernmentOrgRef customer_org = 2;
   */ _define_property(this, "customerOrg", void 0), /**
   * @generated from field: mono.contractintel.v1.GovernmentOrgRef ordering_office = 3;
   */ _define_property(this, "orderingOffice", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentOrgsV2, "runtime", proto3);
_define_property(GovernmentOrgsV2, "typeName", "mono.contractintel.v1.GovernmentOrgsV2");
_define_property(GovernmentOrgsV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contracting_office",
            kind: "message",
            T: GovernmentOrgRef
        },
        {
            no: 2,
            name: "customer_org",
            kind: "message",
            T: GovernmentOrgRef
        },
        {
            no: 3,
            name: "ordering_office",
            kind: "message",
            T: GovernmentOrgRef
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.GovernmentOrgRef
 */ export class GovernmentOrgRef extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentOrgRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentOrgRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentOrgRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentOrgRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * agency / office code
   *
   * @generated from field: string code = 2;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string parent_code = 3;
   */ _define_property(this, "parentCode", ""), /**
   * @generated from field: string parent_name = 4;
   */ _define_property(this, "parentName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentOrgRef, "runtime", proto3);
_define_property(GovernmentOrgRef, "typeName", "mono.contractintel.v1.GovernmentOrgRef");
_define_property(GovernmentOrgRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractPartyV2
 */ export class ContractPartyV2 extends Message {
    static fromBinary(bytes, options) {
        return new ContractPartyV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractPartyV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractPartyV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractPartyV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractPartyRole role = 1;
   */ _define_property(this, "role", 0), /**
   * @generated from field: string legal_entity_name = 2;
   */ _define_property(this, "legalEntityName", ""), /**
   * @generated from field: string cage_code = 3;
   */ _define_property(this, "cageCode", ""), /**
   * @generated from field: string uei = 4;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string duns = 5;
   */ _define_property(this, "duns", ""), /**
   * e.g. "35%"
   *
   * @generated from field: string workshare = 6;
   */ _define_property(this, "workshare", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractPartyV2, "runtime", proto3);
_define_property(ContractPartyV2, "typeName", "mono.contractintel.v1.ContractPartyV2");
_define_property(ContractPartyV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "enum",
            T: proto3.getEnumType(ContractPartyRole)
        },
        {
            no: 2,
            name: "legal_entity_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "workshare",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractDateV2
 */ export class ContractDateV2 extends Message {
    static fromBinary(bytes, options) {
        return new ContractDateV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractDateV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractDateV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractDateV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractDateType type = 1;
   */ _define_property(this, "type", 0), /**
   * @generated from field: google.protobuf.Timestamp value = 2;
   */ _define_property(this, "value", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractDateV2, "runtime", proto3);
_define_property(ContractDateV2, "typeName", "mono.contractintel.v1.ContractDateV2");
_define_property(ContractDateV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(ContractDateType)
        },
        {
            no: 2,
            name: "value",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractPeriodV2
 */ export class ContractPeriodV2 extends Message {
    static fromBinary(bytes, options) {
        return new ContractPeriodV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractPeriodV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractPeriodV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractPeriodV2, a, b);
    }
    constructor(data){
        super(), /**
   * "Base", "Option 1"
   *
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * reused: base / option period / optional task
   *
   * @generated from field: mono.contractintel.v1.CLINOptionType period_type = 2;
   */ _define_property(this, "periodType", 0), /**
   * @generated from field: google.protobuf.Timestamp start = 3;
   */ _define_property(this, "start", void 0), /**
   * @generated from field: google.protobuf.Timestamp end = 4;
   */ _define_property(this, "end", void 0), /**
   * @generated from field: bool exercised = 5;
   */ _define_property(this, "exercised", false), /**
   * Explicit source duration; does not imply a calculated end date.
   *
   * @generated from field: int32 duration_months = 6;
   */ _define_property(this, "durationMonths", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractPeriodV2, "runtime", proto3);
_define_property(ContractPeriodV2, "typeName", "mono.contractintel.v1.ContractPeriodV2");
_define_property(ContractPeriodV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_type",
            kind: "enum",
            T: proto3.getEnumType(CLINOptionType)
        },
        {
            no: 3,
            name: "start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.AwardedClinV2
 */ export class AwardedClinV2 extends Message {
    static fromBinary(bytes, options) {
        return new AwardedClinV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardedClinV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardedClinV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardedClinV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin = 2;
   */ _define_property(this, "parentClin", ""), /**
   * @generated from field: bool is_subline = 3;
   */ _define_property(this, "isSubline", false), /**
   * reused
   *
   * @generated from field: mono.contractintel.v1.SublineType subline_type = 4;
   */ _define_property(this, "sublineType", 0), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * reused
   *
   * @generated from field: mono.contractintel.v1.CLINOptionType option_type = 6;
   */ _define_property(this, "optionType", 0), /**
   * reused
   *
   * @generated from field: mono.contractintel.v1.CLINContractType contract_type = 7;
   */ _define_property(this, "contractType", 0), /**
   * @generated from field: double quantity = 8;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: string unit = 9;
   */ _define_property(this, "unit", ""), /**
   * @generated from field: double unit_price = 10;
   */ _define_property(this, "unitPrice", 0), /**
   * @generated from field: double awarded_amount = 11;
   */ _define_property(this, "awardedAmount", 0), /**
   * @generated from field: double funded_amount = 12;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double unfunded_amount = 13;
   */ _define_property(this, "unfundedAmount", 0), /**
   * @generated from field: double ceiling_amount = 14;
   */ _define_property(this, "ceilingAmount", 0), /**
   * NSP
   *
   * @generated from field: bool not_separately_priced = 15;
   */ _define_property(this, "notSeparatelyPriced", false), /**
   * TBD
   *
   * @generated from field: bool to_be_determined = 16;
   */ _define_property(this, "toBeDetermined", false), /**
   * → ContractPeriodV2.label
   *
   * @generated from field: string pop_period_label = 17;
   */ _define_property(this, "popPeriodLabel", ""), /**
   * → PwsObligationV2.section
   *
   * @generated from field: repeated string pws_section_refs = 18;
   */ _define_property(this, "pwsSectionRefs", []), /**
   * → DeliverableDefinitionV2.number
   *
   * @generated from field: repeated string deliverable_refs = 19;
   */ _define_property(this, "deliverableRefs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardedClinV2, "runtime", proto3);
_define_property(AwardedClinV2, "typeName", "mono.contractintel.v1.AwardedClinV2");
_define_property(AwardedClinV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_subline",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "subline_type",
            kind: "enum",
            T: proto3.getEnumType(SublineType)
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "option_type",
            kind: "enum",
            T: proto3.getEnumType(CLINOptionType)
        },
        {
            no: 7,
            name: "contract_type",
            kind: "enum",
            T: proto3.getEnumType(CLINContractType)
        },
        {
            no: 8,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "awarded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "ceiling_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "not_separately_priced",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "to_be_determined",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 17,
            name: "pop_period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "pws_section_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 19,
            name: "deliverable_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.PwsObligationV2
 */ export class PwsObligationV2 extends Message {
    static fromBinary(bytes, options) {
        return new PwsObligationV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PwsObligationV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PwsObligationV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PwsObligationV2, a, b);
    }
    constructor(data){
        super(), /**
   * e.g. "3.2.1"
   *
   * @generated from field: string section = 1;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string parent_section = 2;
   */ _define_property(this, "parentSection", ""), /**
   * @generated from field: string requirement_text = 3;
   */ _define_property(this, "requirementText", ""), /**
   * @generated from field: mono.contractintel.v1.ObligationType requirement_type = 4;
   */ _define_property(this, "requirementType", 0), /**
   * @generated from field: mono.contractintel.v1.ObligationStrength obligation_strength = 5;
   */ _define_property(this, "obligationStrength", 0), /**
   * @generated from field: string acceptance_criteria = 6;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: string due_date_logic = 7;
   */ _define_property(this, "dueDateLogic", ""), /**
   * @generated from field: repeated string recipients = 8;
   */ _define_property(this, "recipients", []), /**
   * false → superseded by a mod
   *
   * @generated from field: bool current = 9;
   */ _define_property(this, "current", false), /**
   * @generated from field: string superseded_by_section = 10;
   */ _define_property(this, "supersededBySection", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PwsObligationV2, "runtime", proto3);
_define_property(PwsObligationV2, "typeName", "mono.contractintel.v1.PwsObligationV2");
_define_property(PwsObligationV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requirement_type",
            kind: "enum",
            T: proto3.getEnumType(ObligationType)
        },
        {
            no: 5,
            name: "obligation_strength",
            kind: "enum",
            T: proto3.getEnumType(ObligationStrength)
        },
        {
            no: 6,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_date_logic",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "recipients",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "current",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "superseded_by_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.DeliverableDefinitionV2
 */ export class DeliverableDefinitionV2 extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableDefinitionV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableDefinitionV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableDefinitionV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableDefinitionV2, a, b);
    }
    constructor(data){
        super(), /**
   * CDRL number / deliverable id
   *
   * @generated from field: string number = 1;
   */ _define_property(this, "number", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * reused
   *
   * @generated from field: mono.contractintel.v1.DeliverableType type = 3;
   */ _define_property(this, "type", 0), /**
   * @generated from field: bool is_cdrl = 4;
   */ _define_property(this, "isCdrl", false), /**
   * @generated from field: repeated string pws_section_refs = 5;
   */ _define_property(this, "pwsSectionRefs", []), /**
   * @generated from field: repeated string clin_refs = 6;
   */ _define_property(this, "clinRefs", []), /**
   * e.g. "NLT 30 days after kickoff"
   *
   * @generated from field: string due_date_formula = 7;
   */ _define_property(this, "dueDateFormula", ""), /**
   * e.g. "monthly"
   *
   * @generated from field: string recurrence_rule = 8;
   */ _define_property(this, "recurrenceRule", ""), /**
   * @generated from field: string evidence_rule = 9;
   */ _define_property(this, "evidenceRule", ""), /**
   * @generated from field: string proof_rule = 10;
   */ _define_property(this, "proofRule", ""), /**
   * @generated from field: string validation_owner = 11;
   */ _define_property(this, "validationOwner", ""), /**
   * Stable extraction identity, scoped to the originating CLIN when present.
   * Unlike number (the printed CDRL label), distinguishes base/option copies.
   *
   * @generated from field: string definition_id = 12;
   */ _define_property(this, "definitionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableDefinitionV2, "runtime", proto3);
_define_property(DeliverableDefinitionV2, "typeName", "mono.contractintel.v1.DeliverableDefinitionV2");
_define_property(DeliverableDefinitionV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(DeliverableType)
        },
        {
            no: 4,
            name: "is_cdrl",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "pws_section_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "clin_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "due_date_formula",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "recurrence_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "evidence_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "proof_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "validation_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "definition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ContractContactV2
 */ export class ContractContactV2 extends Message {
    static fromBinary(bytes, options) {
        return new ContractContactV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractContactV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractContactV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractContactV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ContractContactRole role = 1;
   */ _define_property(this, "role", 0), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string email = 3;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 4;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string office = 5;
   */ _define_property(this, "office", ""), /**
   * @generated from field: bool is_alternate = 6;
   */ _define_property(this, "isAlternate", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractContactV2, "runtime", proto3);
_define_property(ContractContactV2, "typeName", "mono.contractintel.v1.ContractContactV2");
_define_property(ContractContactV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "enum",
            T: proto3.getEnumType(ContractContactRole)
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "office",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_alternate",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.StaffingRequirementV2
 */ export class StaffingRequirementV2 extends Message {
    static fromBinary(bytes, options) {
        return new StaffingRequirementV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StaffingRequirementV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StaffingRequirementV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StaffingRequirementV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * @generated from field: bool is_key_personnel = 2;
   */ _define_property(this, "isKeyPersonnel", false), /**
   * LCAT
   *
   * @generated from field: string labor_category = 3;
   */ _define_property(this, "laborCategory", ""), /**
   * @generated from field: string clearance = 4;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: repeated string certifications = 5;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: string onboarding_access = 6;
   */ _define_property(this, "onboardingAccess", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StaffingRequirementV2, "runtime", proto3);
_define_property(StaffingRequirementV2, "typeName", "mono.contractintel.v1.StaffingRequirementV2");
_define_property(StaffingRequirementV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "is_key_personnel",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "labor_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "onboarding_access",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.SubcontractRequirementV2
 */ export class SubcontractRequirementV2 extends Message {
    static fromBinary(bytes, options) {
        return new SubcontractRequirementV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubcontractRequirementV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubcontractRequirementV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubcontractRequirementV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string sub_entity = 1;
   */ _define_property(this, "subEntity", ""), /**
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string workshare = 3;
   */ _define_property(this, "workshare", ""), /**
   * authorization-to-proceed gate
   *
   * @generated from field: bool atp_required = 4;
   */ _define_property(this, "atpRequired", false), /**
   * @generated from field: repeated string flowdowns = 5;
   */ _define_property(this, "flowdowns", []), /**
   * @generated from field: double funding = 6;
   */ _define_property(this, "funding", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubcontractRequirementV2, "runtime", proto3);
_define_property(SubcontractRequirementV2, "typeName", "mono.contractintel.v1.SubcontractRequirementV2");
_define_property(SubcontractRequirementV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sub_entity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workshare",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "atp_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "flowdowns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "funding",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ComplianceRequirementV2
 */ export class ComplianceRequirementV2 extends Message {
    static fromBinary(bytes, options) {
        return new ComplianceRequirementV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplianceRequirementV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplianceRequirementV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComplianceRequirementV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ComplianceType type = 1;
   */ _define_property(this, "type", 0), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string cadence = 3;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: string clause_ref = 4;
   */ _define_property(this, "clauseRef", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComplianceRequirementV2, "runtime", proto3);
_define_property(ComplianceRequirementV2, "typeName", "mono.contractintel.v1.ComplianceRequirementV2");
_define_property(ComplianceRequirementV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(ComplianceType)
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clause_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.FinancialTermV2
 */ export class FinancialTermV2 extends Message {
    static fromBinary(bytes, options) {
        return new FinancialTermV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FinancialTermV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FinancialTermV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FinancialTermV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.FinancialTermType type = 1;
   */ _define_property(this, "type", 0), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string value = 3;
   */ _define_property(this, "value", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FinancialTermV2, "runtime", proto3);
_define_property(FinancialTermV2, "typeName", "mono.contractintel.v1.FinancialTermV2");
_define_property(FinancialTermV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "enum",
            T: proto3.getEnumType(FinancialTermType)
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ExtractionSummaryV2
 */ export class ExtractionSummaryV2 extends Message {
    static fromBinary(bytes, options) {
        return new ExtractionSummaryV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractionSummaryV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractionSummaryV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractionSummaryV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double confidence = 1;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: repeated string warnings = 2;
   */ _define_property(this, "warnings", []), /**
   * e.g. "phase4c.v1"
   *
   * @generated from field: string parser_version = 3;
   */ _define_property(this, "parserVersion", ""), /**
   * @generated from field: google.protobuf.Timestamp extracted_at = 4;
   */ _define_property(this, "extractedAt", void 0), /**
   * @generated from field: repeated string source_document_ids = 5;
   */ _define_property(this, "sourceDocumentIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractionSummaryV2, "runtime", proto3);
_define_property(ExtractionSummaryV2, "typeName", "mono.contractintel.v1.ExtractionSummaryV2");
_define_property(ExtractionSummaryV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "parser_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "extracted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "source_document_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ParsedModificationV2
 */ export class ParsedModificationV2 extends Message {
    static fromBinary(bytes, options) {
        return new ParsedModificationV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ParsedModificationV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ParsedModificationV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ParsedModificationV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.contractintel.v1.ModificationIdentityV2 identity = 1;
   */ _define_property(this, "identity", void 0), /**
   * @generated from field: mono.contractintel.v1.ModificationClassification classification = 2;
   */ _define_property(this, "classification", 0), /**
   * effective / signed / issued (reused ContractDateV2)
   *
   * @generated from field: repeated mono.contractintel.v1.ContractDateV2 dates = 3;
   */ _define_property(this, "dates", []), /**
   * @generated from field: mono.contractintel.v1.ModificationAuthorityV2 authority = 4;
   */ _define_property(this, "authority", void 0), /**
   * The core delta list — each entry maps to a canonical ContractChangeItem.
   *
   * @generated from field: repeated mono.contractintel.v1.ModifiedFieldV2 changes = 5;
   */ _define_property(this, "changes", []), /**
   * One SourceMetadata per extracted value (→ a delivery.source_references row).
   *
   * @generated from field: repeated mono.contractintel.v1.SourceMetadata source_references = 20;
   */ _define_property(this, "sourceReferences", []), /**
   * @generated from field: mono.contractintel.v1.ExtractionSummaryV2 extraction_summary = 21;
   */ _define_property(this, "extractionSummary", void 0), /**
   * Facts code could not settle (D93); staged into the Modification set.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 22;
   */ _define_property(this, "reviewItems", []), /**
   * What the modification restates or changes about fields that may carry a
   * review item on file (D96); staging settles or contradicts them.
   *
   * @generated from field: repeated mono.common.v1.ReviewStatement review_statements = 23;
   */ _define_property(this, "reviewStatements", []), /**
   * K10a: the funding the modification itself states it obligates (its
   * obligation sentences plus fund-component sentences outside them), and
   * how many sentences state it; 0 statements when it states none. Reverie
   * reconciles the assembled funding items against it.
   *
   * @generated from field: double stated_obligation_total = 24;
   */ _define_property(this, "statedObligationTotal", 0), /**
   * @generated from field: int32 stated_obligation_statements = 25;
   */ _define_property(this, "statedObligationStatements", 0), /**
   * SAD-789: priced-line duties from the modification's reprinted schedule,
   * scoped to the exercised period. Staged into pangaea and merged by
   * duty_key (new period rules attach; a changed rule is a conflict item).
   *
   * @generated from field: repeated mono.common.v1.AwardPricedDuty priced_duties = 26;
   */ _define_property(this, "pricedDuties", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ParsedModificationV2, "runtime", proto3);
_define_property(ParsedModificationV2, "typeName", "mono.contractintel.v1.ParsedModificationV2");
_define_property(ParsedModificationV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "identity",
            kind: "message",
            T: ModificationIdentityV2
        },
        {
            no: 2,
            name: "classification",
            kind: "enum",
            T: proto3.getEnumType(ModificationClassification)
        },
        {
            no: 3,
            name: "dates",
            kind: "message",
            T: ContractDateV2,
            repeated: true
        },
        {
            no: 4,
            name: "authority",
            kind: "message",
            T: ModificationAuthorityV2
        },
        {
            no: 5,
            name: "changes",
            kind: "message",
            T: ModifiedFieldV2,
            repeated: true
        },
        {
            no: 20,
            name: "source_references",
            kind: "message",
            T: SourceMetadata,
            repeated: true
        },
        {
            no: 21,
            name: "extraction_summary",
            kind: "message",
            T: ExtractionSummaryV2
        },
        {
            no: 22,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        },
        {
            no: 23,
            name: "review_statements",
            kind: "message",
            T: ReviewStatement,
            repeated: true
        },
        {
            no: 24,
            name: "stated_obligation_total",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 25,
            name: "stated_obligation_statements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 26,
            name: "priced_duties",
            kind: "message",
            T: AwardPricedDuty,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ModificationIdentityV2
 */ export class ModificationIdentityV2 extends Message {
    static fromBinary(bytes, options) {
        return new ModificationIdentityV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModificationIdentityV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModificationIdentityV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModificationIdentityV2, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string mod_number = 1;
   */ _define_property(this, "modNumber", ""), /**
   * @generated from field: string parent_contract_number = 2;
   */ _define_property(this, "parentContractNumber", ""), /**
   * @generated from field: string task_order_number = 3;
   */ _define_property(this, "taskOrderNumber", ""), /**
   * @generated from field: string supersedes_mod_number = 4;
   */ _define_property(this, "supersedesModNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModificationIdentityV2, "runtime", proto3);
_define_property(ModificationIdentityV2, "typeName", "mono.contractintel.v1.ModificationIdentityV2");
_define_property(ModificationIdentityV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mod_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "task_order_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "supersedes_mod_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.contractintel.v1.ModificationAuthorityV2
 */ export class ModificationAuthorityV2 extends Message {
    static fromBinary(bytes, options) {
        return new ModificationAuthorityV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModificationAuthorityV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModificationAuthorityV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModificationAuthorityV2, a, b);
    }
    constructor(data){
        super(), /**
   * e.g. "FAR 43.103(a)" / "mutual agreement"
   *
   * @generated from field: string authority_type = 1;
   */ _define_property(this, "authorityType", ""), /**
   * @generated from field: string clause_ref = 2;
   */ _define_property(this, "clauseRef", ""), /**
   * @generated from field: string issuing_office = 3;
   */ _define_property(this, "issuingOffice", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModificationAuthorityV2, "runtime", proto3);
_define_property(ModificationAuthorityV2, "typeName", "mono.contractintel.v1.ModificationAuthorityV2");
_define_property(ModificationAuthorityV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "authority_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "clause_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "issuing_office",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ModifiedFieldV2 is one changed value (old → new). Its diff_type and
 * change_category deliberately mirror the canonical ContractChangeItem string
 * sets so the Slice-3 mapping onto a ChangeSet is mechanical.
 *
 * @generated from message mono.contractintel.v1.ModifiedFieldV2
 */ export class ModifiedFieldV2 extends Message {
    static fromBinary(bytes, options) {
        return new ModifiedFieldV2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModifiedFieldV2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModifiedFieldV2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModifiedFieldV2, a, b);
    }
    constructor(data){
        super(), /**
   * CLIN | PeriodOfPerformance | DeliverableDefinition | Contact | PwsObligation | Program
   *
   * @generated from field: string target_object_type = 1;
   */ _define_property(this, "targetObjectType", ""), /**
   * e.g. "0004"
   *
   * @generated from field: string target_object_id = 2;
   */ _define_property(this, "targetObjectId", ""), /**
   * e.g. "funded_amount"
   *
   * @generated from field: string target_field_path = 3;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: mono.contractintel.v1.DiffTypeV2 diff_type = 4;
   */ _define_property(this, "diffType", 0), /**
   * @generated from field: mono.contractintel.v1.ModChangeCategory change_category = 5;
   */ _define_property(this, "changeCategory", 0), /**
   * current authoritative value (empty + warning when unestablished)
   *
   * @generated from field: string old_value_json = 6;
   */ _define_property(this, "oldValueJson", ""), /**
   * proposed value from the modification
   *
   * @generated from field: string new_value_json = 7;
   */ _define_property(this, "newValueJson", ""), /**
   * false → reviewer must confirm the baseline (spec §7.1)
   *
   * @generated from field: bool old_value_established = 8;
   */ _define_property(this, "oldValueEstablished", false), /**
   * index into source_references for the old value (-1 if none)
   *
   * @generated from field: int32 source_before_index = 9;
   */ _define_property(this, "sourceBeforeIndex", 0), /**
   * index into source_references for the new value (-1 if none)
   *
   * @generated from field: int32 source_after_index = 10;
   */ _define_property(this, "sourceAfterIndex", 0), /**
   * @generated from field: double confidence = 11;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: repeated string warnings = 12;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ModifiedFieldV2, "runtime", proto3);
_define_property(ModifiedFieldV2, "typeName", "mono.contractintel.v1.ModifiedFieldV2");
_define_property(ModifiedFieldV2, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "diff_type",
            kind: "enum",
            T: proto3.getEnumType(DiffTypeV2)
        },
        {
            no: 5,
            name: "change_category",
            kind: "enum",
            T: proto3.getEnumType(ModChangeCategory)
        },
        {
            no: 6,
            name: "old_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "new_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "old_value_established",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "source_before_index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "source_after_index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
